import { React, useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap1,
  SolutionContainer,
  TableLayoutData,
  ContentMiddle,
  DownArrowDraw,
  HaberForm,
  //   PipeDesign,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Progress,
  Collapse,
  Radio,
} from "antd";
import { Styled, RadioButtonStyle, RadioButtonStyle1 } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { TableList, RightSideSolution } from "../../pageStyled";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
// import { HaberForm } from "../../styledElements";
import {
  getFailedGroups,
  // getJobCardCylinders,
  getJobCardsById,
  getJobCardsDetails,
  putSolutionStatus,
  cancelJobCard,
  getAlgorithmCompletionStatus,
  getIntermediateList,
  createNewSolution,
  getJobCardsDetailsMultistage,
  createNewSolutionMultistage,
  readyJobCardMultistageNewSolution,
  getAlgorithmCompletionStatusMultiStage,
  putSolutionStatusMultistage,
  getShortJobCardCylindersMultistage,
  unselectGrpOfAcceptedJobcards,
} from "../../../Services/deckleMatchServices";
import { editQtyToBePlannedForReviewOrder, getOrdersList } from "../../../Services/orderServices";
import moment from "moment";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import IcoMoon from "react-icomoon";
import deckleCover from "../../../Assets/Images/deckle-match-result-cover.svg";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import vectorIco from "../../../Assets/Icons/vectorIco.svg";
import alerttrue from "../../../Assets/Icons/alerttrue.svg";
import wrongIco from "../../../Assets/Icons/wrongIco.svg";
import failedIco from "../../../Assets/Icons/failedIco.svg";
import greaterRange from "../../../Assets/Icons/up-range.svg";
import lowerRange from "../../../Assets/Icons/down-range.svg";
import { getStockSizesDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import { useInterval } from "../../../Utils/polling/pollingConfig";
import CreateNewSolutionMultistage from "../DeckleResults/createNewSolutionMultistage";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import LottieAnimation from "../../../Lottie";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
//import TabPane from "antd/lib/tabs/TabPane";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import JobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/JobCardCylinderContainerMultistage";
import SheetJobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainerMultistage";
import { getUnitData } from "../../../Services/measurementService";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";
import { toHandlePOName } from "../../../Utils/helper/helper";
import CreateNewSolCompare from "./CreateNewSolCompare";



const { TabPane } = Tabs;
const Panes = Tabs.TabPane;

const DeckleMatchResultsMultistage = () => {
  const stopCancellApi = useRef(false);
  const { stopCancelled, setStopCancelled, handleResetAll,handleBackPathForJC,setAcceptedJCGrpCode,acceptedJCGrpCode,removeGrpsFromOrderSummary } = useContext(JobCardDataContext);
  const location = useLocation();
  const history = useNavigate();
  const [failedGroups, setFailedGroups] = useState([]);
  const [totalGroups, setTotalGroups] = useState(
    location.state?.jobCards.total_groups
  );
  const [jobcardIds, setJobcardIds] = useState(location.state?.jobCards.jobcards);
  const [jobcardIdsWithCode, setJobcardIdsWithCode] = useState([]);
  const [solutionList, setSolutionList] = useState([]);
  const [currentSolution, setCurrentSolution] = useState("compare");
  const [currentCylinderData, setCurrentCylinderData] = useState();
  const [currentNewSolCylinderData, setCurrentNewSolCylinderData] = useState();
  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const matchTrimLossKey = "match_trim_loss_%_(a-b)";
  const matchFulfilmentKey = "requirement_fulfilled_%_(a-b)";
  const [activeJobcard, setActiveJobcard] = useState();
  const [activeJC, setActiveJC] = useState();
  const [renderKey, setRenderKey] = useState(false);
  const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
  const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [solutionTableData, setSolutionTableData] = useState();
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [sizesTabData, setSizesTabData] = useState([]);
  const [ordersIdList, setOrderIdList] = useState([]);
  const [failedJobOrders, setFailedJobOrders] = useState([]);
  const [intermediateData, setIntermediateData] = useState([]);
  const [unitData, setUnitData] = useState();
  const [isJobcardView, setIsJobcardView] = useState(true);
  const [failedNewSol, setFailedNewSol] = useState({});
  const [isSheetView, setIsSheetView] = useState(true);
  const [isTabularView, setIsTabularView] = useState(false);
    const [cylinderViewData, setCylinderViewData] = useState('order');
  const [showAimation, setShowAimation] = useState({});
  // Avoid forcing re-renders; keep updates immutable instead.
  const [optimizePartition, setOptimizePartition] = useState(false);
  const [minimizeOverfulfillment, setMinimizeOverfulfillment] = useState(false);
  const [isAcceptModal, setIsAcceptModal] = useState(false);
  const [isDiscardModal, setIsDiscardModal] = useState(false);
  const [newSolutionAccepted, setNewSolutionAccepted] = useState(false);
  const [isSolutionAccepted, setIsSolutionAccepted] = useState();
  const [isAcceptLoading, setIsAcceptLoading] = useState(false);
  const [isDiscardLoading, setIsDiscardLoading] = useState(false);
  const [viewOrder, setViewOrder] = useState(false);
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder,setSelectedOrder]= useState();
  const [currentSummaryTab, setCurrentSummaryTab] = useState("1");
  const [syncFailedGroups, setSyncFailedGroups] = useState(false);
  const [createNewSolutionClicked, setCreateNewSolutionClicked] =
    useState(false);
  const [isNewSolutionPolling, setIsNewSolutionPolling] = useState(false);
  const [paperMachineFormValues, setPaperMachineFormValues] = useState(
    getFormObject()
  );
  const [failedJobs, setFailedJobs] = useState([]);
  const [jobIndex, setJobIndex] = useState(0);
  const [stockSizes, setStockSizes] = useState([]);
  const [stockSizesByJobCard, setStockSizesByJobCard] = useState({});
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [sizeExpanded, setSizeExpanded] = useState(false); 
  // const [sizeExpanded, setSizeExpanded] = useState(false); 
  // const [sizeExpanded, setSizeExpanded] = useState(false); 
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  /** @param {string} [item] */
  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
  const [
    createNewSolutionFormValuesByJobCard,
    setCreateNewSolutionFormValuesByJobCard,
  ] = useState({});
  const [formValuesForStock, setFormValuesForStock] = useState({});
  const currentActiveJC = useRef();
  const activeJobcardRef = useRef();
  const [isDataLoad,setIsDataLoad] = useState(true);
  const [compareSolSummaryData,setCompareSolSummaryData] = useState([]);
  const [newCompareSolSummaryData,setNewCompareSolSummaryData] = useState([]);
const [acceptSolCounter,setAcceptSolCounter] = useState(false);
  const [ordersIdListByJobCard, setOrdersIdListByJobCard] = useState({});
  const newSolutionMappingRef = useRef({});
  const newSolutionPollingInFlightRef = useRef(false);
  const newSolutionPollingActiveRef = useRef(false);
  const newSolutionPendingParentsRef = useRef(new Set());
  const newSolutionAppliedNewIdsByParentRef = useRef({});
  const newSolutionResolvedParentsRef = useRef(new Set());
  // Tracks parent jobcard ids currently undergoing "create new solution":
  // { [parentId]: null | newJobcardId }
  const [newSolutionByParentId, setNewSolutionByParentId] = useState({});
  const newSolutionByParentIdRef = useRef({});
  const jobCardDetailsListRef = useRef([]);
  
  /** Keeps a ref in sync with job card list for polling callbacks without stale closures. */
  useEffect(() => {
    jobCardDetailsListRef.current = jobCardDetailsList;
  }, [jobCardDetailsList]);

  /** Keeps a ref in sync with new-solution tracking state (avoid stale closures in polling). */
  useEffect(() => {
    newSolutionByParentIdRef.current = newSolutionByParentId || {};
  }, [newSolutionByParentId]);

  /**
   * Normalizes API `jobcard_output_mapping` keys/values to numeric parent id → new id(s).
   * @param {Record<string, unknown>} mapping
   */
  const normalizeJobcardOutputMapping = (mapping) => {
    if (!mapping || typeof mapping !== "object") return {};
    const out = {};
    for (const [k, v] of Object.entries(mapping)) {
      const parentId = parseInt(k, 10);
      if (!Number.isFinite(parentId)) continue;

      if (Array.isArray(v)) {
        const ids = v
          .map((x) => parseInt(x, 10))
          .filter((x) => Number.isFinite(x));
        if (ids.length) out[parentId] = ids;
        continue;
      }

      const newId = parseInt(v, 10);
      if (Number.isFinite(newId)) out[parentId] = newId;
    }
    return out;
  };

  /** Merges a new poll snapshot into `newSolutionMappingRef` (supports scalar or array per parent). */
  const mergeNewSolutionMapping = (nextMapping) => {
    const normalized = normalizeJobcardOutputMapping(nextMapping);
    const prev = newSolutionMappingRef.current || {};
    const merged = { ...prev };

    for (const [parentIdStr, newVal] of Object.entries(normalized)) {
      const parentId = parseInt(parentIdStr, 10);
      const prevVal = merged[parentId];

      if (Array.isArray(prevVal) || Array.isArray(newVal)) {
        const prevArr = Array.isArray(prevVal)
          ? prevVal
          : prevVal !== undefined
            ? [prevVal]
            : [];
        const newArr = Array.isArray(newVal) ? newVal : [newVal];
        merged[parentId] = Array.from(new Set([...prevArr, ...newArr]));
      } else {
        merged[parentId] = newVal;
      }
    }

    newSolutionMappingRef.current = merged;
  };

  /** Returns true if the parent row already contains all given newly-created ids. */
  const parentHasNewSolutionIds = (parentId, ids) => {
    const list = jobCardDetailsListRef.current || [];
    const row = list.find((x) => x?.id === parentId);
    if (!row) return false;
    const existing = row?.newlyCreatedJobCardsDetails || [];
    if (!existing?.length) return false;
    const existingIds = new Set(existing.map((x) => parseInt(x?.id, 10)).filter(Number.isFinite));
    return (ids || []).every((id) => existingIds.has(parseInt(id, 10)));
  };

  /** Stops loading animation for one parent and clears it from the pending set; stops polling when empty. */
  const markParentResolved = (parentId) => {
    const list = jobCardDetailsListRef.current || [];
    const idx = list.findIndex((x) => x?.id === parentId);
    if (idx !== -1) {
      setShowAimation((prev) => ({ ...prev, [idx]: false }));
    }
    // Do NOT stop polling here. We keep polling until backend returns `done: true`.
    // This avoids premature stop when running "new solution on new solution".
    const nextResolved = new Set(newSolutionResolvedParentsRef.current || []);
    nextResolved.add(parentId);
    newSolutionResolvedParentsRef.current = nextResolved;
  };
  /** Parent callback: toggles "optimize unique partitions" for new solution. */
  const handleOptimizePartitionChange = (isChecked) => {
    setOptimizePartition(isChecked);
  };
  /** Parent callback: toggles "minimize overfulfillment" for new solution. */
  const handleMinimizeOverfulfillmentChange = (isChecked) => {
    setMinimizeOverfulfillment(isChecked);
  };
  const selectedJobCardId = jobCardDetailsList?.[jobIndex]?.id;
  const defaultOrdersIdList =
    jobCardDetailsList?.[jobIndex]?.jobcard?.group?.orders?.map(
      (order) => order.order_id
    ) || [];
  const currentOrdersIdList = selectedJobCardId
    ? (ordersIdListByJobCard[selectedJobCardId] ?? defaultOrdersIdList)
    : [];

  const setStockSizesForActiveJobcard = (nextStockSizes) => {
    const jcId = jobCardDetailsList?.[jobIndex]?.id;
    const updatedStockSizes =
      typeof nextStockSizes === "function"
        ? nextStockSizes(stockSizesByJobCard?.[jcId] || [])
        : nextStockSizes;
    setStockSizes(updatedStockSizes);
    if (!jcId) return;
    setStockSizesByJobCard((prev) => ({
      ...prev,
      [jcId]: updatedStockSizes,
    }));
  };

  const setOrdersIdListForActiveJobcard = (nextOrdersIdList) => {
    const jcId = jobCardDetailsList?.[jobIndex]?.id;
    const updatedOrdersIdList =
      typeof nextOrdersIdList === "function"
        ? nextOrdersIdList(ordersIdListByJobCard?.[jcId] || [])
        : nextOrdersIdList;
    setOrderIdList(updatedOrdersIdList);
    if (!jcId) return;
    setOrdersIdListByJobCard((prev) => ({
      ...prev,
      [jcId]: updatedOrdersIdList,
    }));
  };
  /** Opens the discard-solution confirmation modal. */
  const discardModalShow = (value) => {
    setIsDiscardModal(true);
  };

  const discardModalClose = () => {
    setIsDiscardModal(false);
  };
  /** Confirms discard: marks current solution as rejected via API and updates local state. */
  const discardModalConfirm = () => {
    setIsDiscardModal(false);
    setIsDiscardLoading(true);
    let jobCardId =
      currentSolution == 1 || currentSolution == 2
        ? jobCardDetailsList[jobIndex].id
        : jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0].id;
    let solutionState =
      currentSolution == 1 || currentSolution == 3
        ? "solution_1"
        : "solution_2";
    putSolutionStatus(jobCardId, solutionState, "reject")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            const row = next[jobIndex];
            if (!row) return prev;

            if (currentSolution == 1 || currentSolution == 2) {
              next[jobIndex] = {
                ...row,
                jobcard: {
                  ...row.jobcard,
                  [solutionState]: {
                    ...row.jobcard?.[solutionState],
                    status: "reject",
                  },
                },
              };
            } else {
              const ncd = row?.newlyCreatedJobCardsDetails || [];
              if (!ncd.length) return prev;
              const first = ncd[0];
              const updatedFirst = {
                ...first,
                jobcard: {
                  ...first.jobcard,
                  [solutionState]: {
                    ...first.jobcard?.[solutionState],
                    status: "reject",
                  },
                },
              };
              next[jobIndex] = {
                ...row,
                newlyCreatedJobCardsDetails: [updatedFirst, ...ncd.slice(1)],
              };
            }

            return next;
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsDiscardLoading(false);
      });
  };
  /** Opens the accept-solution confirmation modal. */
  const acceptModalShow = (value) => {
    setIsAcceptModal(true);
  };

  /** Closes the order drawer opened by `showViewDrawer`. */
  const closeViewDrawer = () => {
    setViewOrder(false);
  };
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  /**
   * Polls GET `/jobcards/new-solution/multistage/?ready` every 5s while parents are pending.
   * Batches detail fetches and merges new job cards per parent; stops per-parent animation when data arrives.
   */
  const pollReadyNewSolutionOnce = async () => {
    if (newSolutionPollingInFlightRef.current) return;
    if (stopCancellApi?.current) return;
    newSolutionPollingInFlightRef.current = true;
    try {
      const res = await readyJobCardMultistageNewSolution();
      console.log("res", res);
      if (res?.jobcard_output_mapping) {
        mergeNewSolutionMapping(res.jobcard_output_mapping);
      }

      const mapping = newSolutionMappingRef.current || {};
      const tracked = newSolutionByParentIdRef.current || {};
      const parentsToApply = Object.entries(tracked)
        .filter(([, v]) => v === null)
        .map(([k]) => parseInt(k, 10))
        .filter((pid) => Number.isFinite(pid) && Object.prototype.hasOwnProperty.call(mapping, pid));

      // If all tracked parents have resolved ids, stop polling (regardless of `done`, which can be true anytime).
      const unresolvedParents = Object.entries(tracked)
        .filter(([, v]) => v === null)
        .map(([k]) => parseInt(k, 10))
        .filter(Number.isFinite);
      if (!unresolvedParents.length && Object.keys(tracked).length) {
        newSolutionPollingActiveRef.current = false;
        setIsNewSolutionPolling(false);
        return;
      }

      // Build a single batched fetch list for this tick to avoid N calls.
      const idsToFetchByParent = {};
      const allIdsToFetch = [];
      for (const parentId of parentsToApply) {
        const newVal = mapping[parentId];
        const newIds = (Array.isArray(newVal) ? newVal : [newVal])
          .map((x) => parseInt(x, 10))
          .filter((x) => Number.isFinite(x));
        if (!newIds.length) continue;

        // Always prefer the latest id for this parent (new-solution-on-new-solution overwrites prior).
        const latestId = newIds[newIds.length - 1];
        if (!Number.isFinite(latestId)) continue;
        idsToFetchByParent[parentId] = [latestId];
        allIdsToFetch.push(latestId);
      }

      const uniqueIdsToFetch = Array.from(new Set(allIdsToFetch));
      if (uniqueIdsToFetch.length) {
        const details = await getJobCardsDetailsMultistage({ jobcards: uniqueIdsToFetch });
        if (!details || !details.length) {
          // Keep polling until done becomes true.
        } else {
          const detailsById = new Map();
          details.forEach((d) => {
            if (d?.id !== undefined) detailsById.set(d.id, d);
          });

          // Apply all parent updates in a single state update to avoid repeated renders.
          const parentsResolvedThisTick = [];
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            for (const [parentIdStr, ids] of Object.entries(idsToFetchByParent)) {
              const parentId = parseInt(parentIdStr, 10);
              const idx = next.findIndex((x) => x?.id === parentId);
              if (idx === -1) continue;

              const fetchedDetails = ids.map((id) => detailsById.get(id)).filter(Boolean);
              if (!fetchedDetails.length) continue;

              // Always replace with ONLY the latest new-solution jobcard for this parent.
              const latest = fetchedDetails[fetchedDetails.length - 1];
              const mergedDetails = latest ? [latest] : [];

              next[idx] = {
                ...next[idx],
                newlyCreatedJobCardsDetails: mergedDetails,
                ...(next[idx]?.isFailedJobcard ? { isSuccessful: true } : {}),
              };
              parentsResolvedThisTick.push(parentId);
            }
            setNewCompareSolSummaryData({ solution1: next, solution2: next });
            return next;
          });

          // Stop animation for parents we actually updated.
          parentsResolvedThisTick.forEach((pid) => markParentResolved(pid));
          // Update tracking state: parentId -> latestId
          setNewSolutionByParentId((prev) => {
            const next = { ...(prev || {}) };
            for (const [parentIdStr, ids] of Object.entries(idsToFetchByParent)) {
              const parentId = parseInt(parentIdStr, 10);
              const latestId = Array.isArray(ids) ? ids[ids.length - 1] : ids;
              if (Number.isFinite(parentId) && Number.isFinite(latestId)) next[parentId] = latestId;
            }
            return next;
          });
        }
      }
    } catch (e) {
      // stop polling on hard error; user can retry create flow
      newSolutionPollingActiveRef.current = false;
      setIsNewSolutionPolling(false);
    } finally {
      newSolutionPollingInFlightRef.current = false;
    }
  };

  useInterval(async () => {
    if (!newSolutionPollingActiveRef.current) return;
    if (!isNewSolutionPolling) return;
    await pollReadyNewSolutionOnce();
  }, 5000);
   async function process_failed_groups() {
    while (true) {
      try {
        let response = await getAlgorithmCompletionStatusMultiStage();
        // response.data = {
        //   done: true,
        //   jobcards: [43396, 43397, 43398, 43399, 43400],
        //   total_groups: 9,
        //   failed_groups: [15890, 15891, 15892],
        // };
        if (response.data.total_groups == response.data.jobcards.length && JSON.stringify(jobcardIds) !== JSON.stringify(response.data.jobcards)) {
          setJobcardIds(response.data.jobcards);
          return;
        }
        if (
          response.data.done &&
          response.data.total_groups ===
            response.data.failed_groups.length + response.data.jobcards.length
        ) {
          if(JSON.stringify(jobcardIds) !== JSON.stringify(response.data.jobcards))
            setJobcardIds(response.data.jobcards);
          setSyncFailedGroups(true);
          // setTimeout(() => {
          setFailedGroups(response.data.failed_groups);
          // }, 3000);
          return;
        }
      } catch (error) {
        return;
      } finally {
      }
      await sleep(5000);
    }
  }
  /** Closes accept modal without confirming. */
  const acceptModalClose = () => {
    setIsAcceptModal(false);
  };
  /** Loads stock orders for a group that need cutter reel-diameter updates. */
  const getUpdatedOrders = async (group) => {
    try {
      const response = await getOrdersList(group?.orders?.map((order) => order.item_type == "stock" && order.order_id)?.sort());
      return response?.data?.filter(order => order.cutter_reel_dia === true);
    } catch (error) {
      console.error("Error fetching orders list:", error);
      throw error;
    }
  };

  /** Builds `editQtyToBePlannedForReviewOrder` payloads for reel OD from machine or form values. */
  const createRequest = (ordersList, group, machine, isManualInput, min, max, unit) => {
    return ordersList?.map(order => {
      const isConstant = isManualInput ? (min === max) : (machine.minimum_reel_dia === machine.maximum_reel_dia);
      const reelOdValue = isManualInput ? `${max} ${unit}` : `${machine.minimum_reel_dia} ${machine.units}`;
      const unitsValue = isManualInput ? unit : machine.units?.minimum_reel_dia;

      return {
        order_id: JSON.stringify(order.id),
        planned_weight: order?.planned_weight,
        reel_od: isConstant ? [reelOdValue] : {
          minimum_reel_od: isManualInput ? min : machine.minimum_reel_dia,
          maximum_reel_od: isManualInput ? max : machine.maximum_reel_dia,
        },
        group_id: group.group_id,
        od_type: isConstant ? "constant" : "range",
        cutter_reel_dia: true,
        units: isConstant ? {
          planned_weight: order?.units?.planned_weight,
        } : {
          planned_weight: order?.units?.planned_weight,
          minimum_reel_od: unitsValue,
          maximum_reel_od: unitsValue
        }
      };
    });
  };

  /**
   * Persists cutter reel OD (from machine defaults or form `e`) onto orders that have `cutter_reel_dia`.
   * Skips while a new-solution animation is running for the active job card.
   */
  const handleCutterReelDiaChange = async (e, cutterMachine) => {
    if (showAimation[jobIndex]) return;

    const isManualInput = Boolean(e);
    const group = jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.[0]?.jobcard?.group || jobCardDetailsList[jobIndex].jobcard?.group;
    if (!group) return;

    try {
      const ordersList = await getUpdatedOrders(group);
      if (!ordersList?.length) return;

      let request;
      if (!isManualInput) {
        const machine = group?.machines?.find(machine => machine.machine_type === "cutter");
        if (!machine) return;

        request = createRequest(ordersList, group, machine, false);
      } else {
        const min = parseFloat(e.min_dia_cutter);
        const max = parseFloat(e.max_dia_cutter);
        const unit = e.reel_dia_unit_cutter;

        if (min === cutterMachine.minimum_reel_dia && max === cutterMachine.maximum_reel_dia && unit === cutterMachine.units) return;

        request = createRequest(ordersList, group, cutterMachine, true, min, max, unit);
      }

      if (!request?.length) return;

      const response = await editQtyToBePlannedForReviewOrder(request, "new_solution");
    } catch (error) {
      console.log("Error in updating order:", error?.response?.data);
    }
  };

  /**
   * Submits multistage "new solution" from the child form: builds request, calls create API,
   * then relies on polling (`readyJobCardMultistageNewSolution`) to attach new job cards per parent.
   */
  const onClickCreateSolution = async (e, jobCardId, uuid, jobIndex) => {
    setActiveTab('1');
    setCurrentSummaryTab('1');
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setShowAimation((prev) => {
      return { ...prev, [jobIndex]: true };
    });

    // Track this parent as "in progress" (null) every time user clicks create solution,
    // including "new solution on existing new solution".
    setNewSolutionByParentId((prev) => ({ ...(prev || {}), [jobCardId]: null }));
    
    newSolutionAppliedNewIdsByParentRef.current = {
      ...(newSolutionAppliedNewIdsByParentRef.current || {}),
      [jobCardId]: [],
    };
    // Also clear any "resolved" marker for this parent so animation/polling behaves correctly.
    const nextResolved = new Set(newSolutionResolvedParentsRef.current || []);
    nextResolved.delete(jobCardId);
    newSolutionResolvedParentsRef.current = nextResolved;
    if (newSolutionMappingRef.current?.[jobCardId] !== undefined) {
      const nextMap = { ...(newSolutionMappingRef.current || {}) };
      delete nextMap[jobCardId];
      newSolutionMappingRef.current = nextMap;
    }

    let sizes = [];
    setCreateNewSolutionFormValuesByJobCard((prev) => ({
      ...prev,
      [jobCardId]: e,
    }));
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        let sizeObject = {
          id: size.stockSizeId,
          //size: size.stockSize,
          allowed_quantity: parseFloat(size.allowedQuantity),
          reels: size.reels,
          planned_weight: parseFloat(size.plannedWeight),
          type: size.type,
          sheets: size.sheets,
          
          ...((size.type === "sheet") && {lateral_size: size.length,
            grain: size.grain,
          }),
          ...((size.type === "reel") && {
            grain: null,
          }),
          size: size.width,
          mixed_grain: false,
          ...(size.creation_type === "required" && {
            weight_lb: parseFloat(size.weight_lb),
            weight_ub: parseFloat(size.weight_ub),
            
            priority_stock: size.priority_stock,
          }),
          units: {
            ...size.units,
            
            lateral_size: size.units.length,
            size: size.units.width ,
          },         
          creation_type: size.creation_type,
        };
        sizes.push(sizeObject);
      });
    }
    let updatedFormValues = { ...formValuesForStock?.[jobIndex] };
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : updatedFormValues?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : updatedFormValues?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : updatedFormValues?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : updatedFormValues?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : updatedFormValues?.cutters;
    updatedFormValues["effective_deckle_length"] = e.cutters
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues["units"] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.deckleLengthUnit,
      deckle_size_ub: e.deckleLengthUnit,
      deckle_size_lb: e.deckleLengthUnit,
    };
    updatedFormValues["max_deckle_length_cutter"] = e.maxDeckleLengthCutter
      ? parseFloat(e.maxDeckleLengthCutter)
      : updatedFormValues?.max_deckle_length;
    updatedFormValues["min_deckle_length_cutter"] = e.minDeckleLengthCutter
      ? parseFloat(e.minDeckleLengthCutter)
      : updatedFormValues?.min_deckle_length;
    updatedFormValues["left_edge_trim_cutter"] = e.minWidthCutter
      ? parseFloat(e.minWidthCutter)
      : updatedFormValues?.left_edge_trim;
    updatedFormValues["right_edge_trim_cutter"] = e.maxWidthCutter
      ? parseFloat(e.maxWidthCutter)
      : updatedFormValues?.right_edge_trim;
    updatedFormValues["maximum_cutters_cutter"] = e.cuttersCutter
      ? parseFloat(e.cuttersCutter)
      : updatedFormValues?.cuttersCutter;
    updatedFormValues["effective_deckle_length_cutter"] =
      e.effectiveDeckleLengthCutter
        ? parseFloat(e.effectiveDeckleLengthCutter)
        : "";
    updatedFormValues["min_dia_cutter"] = parseFloat(e.min_dia_cutter);
    updatedFormValues["max_dia_cutter"] = parseFloat(e.max_dia_cutter);
    updatedFormValues["min_chop_cutter"] = parseFloat(e.min_chop_cutter);
    updatedFormValues["max_chop_cutter"] = parseFloat(e.max_chop_cutter);
    updatedFormValues["max_trim_intermediate_cutter"] = parseFloat(
      e.max_trim_intermediate_cutter
    );
    updatedFormValues["units_cutter"] = {
      ...e.units_cutter,
      max_deckle_length: e.deckleLengthUnitCutter,
      min_deckle_length: e.deckleLengthUnitCutter,
      left_edge_trim: e.widthUnitCutter,
      right_edge_trim: e.widthUnitCutter,
      effective_deckle_length: e.deckleLengthUnitCutter,
      minimum_reel_dia: e.reel_dia_unit_cutter,
      maximum_reel_dia: e.reel_dia_unit_cutter,
      max_chop_size: e.chopUnit,
      min_chop_cutter: e.chopUnit,
      deckle_size_ub: e.deckleLengthUnitCutter,
      deckle_size_lb: e.deckleLengthUnitCutter,
      allowed_trim: e.max_trim_intermediate_unit_cutter,
    };

    setFormValuesForStock({ ...formValuesForStock, [jobIndex]: updatedFormValues });
    const rewinderMachine = jobCardDetailsList[
      jobIndex
    ].jobcard?.group?.machines?.find(
      (machine) => machine.machine_type === "rewinder"
    );
    const cutterMachine = jobCardDetailsList[
      jobIndex
    ].jobcard?.group?.machines?.find(
      (machine) => machine.machine_type === "cutter"
    );

    let request = {
      [`${jobCardDetailsList[jobIndex]?.isFailedJobcard ? "failed_group": "jobcard"}`]: jobCardDetailsList[jobIndex]?.isFailedJobcard? jobCardDetailsList[jobIndex]?.failedGroupId : location?.state?.parentJCid || jobCardId,
      run_type: "selected_sizes",
      machine_selection_data: [
        {
          ...rewinderMachine,
          maximum_deckle_size: e.maxDeckleLength
            ? parseFloat(e.maxDeckleLength)
            : updatedFormValues?.max_deckle_length,
          minimum_deckle_size: e.minDeckleLength
            ? parseFloat(e.minDeckleLength)
            : updatedFormValues?.min_deckle_length,
          left_edge_trim: e.minWidth
            ? parseFloat(e.minWidth)
            : updatedFormValues?.left_edge_trim,
          right_edge_trim: e.maxWidth
            ? parseFloat(e.maxWidth)
            : updatedFormValues?.right_edge_trim,
          maximum_cutters: e.cutters
            ? parseFloat(e.cutters)
            : updatedFormValues?.maximum_cutters,
          effective_deckle_length: e.effectiveDeckleLength
            ? parseFloat(e.effectiveDeckleLength)
            : "",
          units: {
            maximum_deckle_size: e.deckleLengthUnit,
            minimum_deckle_size: e.deckleLengthUnit,
            left_edge_trim: e.widthUnit,
            right_edge_trim: e.widthUnit,
            effective_deckle_length: e.deckleLengthUnit,
          },
        },
        {
          ...cutterMachine,
          maximum_deckle_size: e.maxDeckleLengthCutter >=0
            ? parseFloat(e.maxDeckleLengthCutter)
            : updatedFormValues?.max_deckle_length_cutter,
          minimum_deckle_size: e.minDeckleLengthCutter >=0
            ? parseFloat(e.minDeckleLengthCutter)
            : updatedFormValues?.min_deckle_length_cutter,
          left_edge_trim: e.minWidthCutter >=0
            ? parseFloat(e.minWidthCutter)
            : updatedFormValues?.left_edge_trim_cutter,
          right_edge_trim: e.maxWidthCutter >=0
            ? parseFloat(e.maxWidthCutter)
            : updatedFormValues?.right_edge_trim_cutter,
          maximum_cutters: e.cuttersCutter >=0
            ? parseFloat(e.cuttersCutter)
            : updatedFormValues?.maximum_cutters_cutter,
          effective_deckle_length: e.effectiveDeckleLengthCutter
            ? parseFloat(e.effectiveDeckleLengthCutter)
            : "",
          minimum_reel_dia: parseFloat(e.min_dia_cutter),
          maximum_reel_dia: parseFloat(e.max_dia_cutter),
          max_chop_size: parseFloat(e.max_chop_cutter),
          min_chop_size: parseFloat(e.min_chop_cutter),
          allowed_trim: parseFloat(e.max_trim_intermediate_cutter),
          units: {
            maximum_deckle_size: e.deckleLengthUnitCutter,
            minimum_deckle_size: e.deckleLengthUnitCutter,
            left_edge_trim: e.widthUnit_cutter,
            right_edge_trim: e.widthUnit_cutter,
            effective_deckle_length: e.deckleLengthUnitCutter,
            minimum_reel_dia: e.reel_dia_unit_cutter,
            maximum_reel_dia: e.reel_dia_unit_cutter,
            max_chop_size: e.chopUnit,
            min_chop_size: e.chopUnit,
            allowed_trim: e.max_trim_intermediate_unit_cutter,
          },
        },
      ],
      sizes: sizes,
      optimize_unique_partitions: optimizePartition,
      minimize_overfulfillment: minimizeOverfulfillment,
    };
    await handleCutterReelDiaChange(e, cutterMachine);
    try {
      setCreateNewSolutionClicked(true);
      // This API triggers async creation; it does not return the jobcard data immediately.
      await createNewSolutionMultistage(request);
      // allow user to start new solution for other jobcards while this one cooks
      setCreateNewSolutionClicked(false);
      newSolutionPollingActiveRef.current = true;
      setIsNewSolutionPolling(true);
      // Initiate Ready API immediately on click (do not wait for the next 5s interval).
      pollReadyNewSolutionOnce();
      newSolutionPendingParentsRef.current = new Set([
        ...(newSolutionPendingParentsRef.current || new Set()),
        jobCardId,
      ]);
      setShowAimation((prev) => ({ ...prev, [jobIndex]: true }));
      setCurrentSolution("3");

      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: false };
      });
    } catch (error) {
      let jobcardResp = [];
      let response = [];

      // console.log(error?.response?.data?.data?.group_id, error?.response?.data?.data, response);
      if(error?.response?.data?.data?.group_id){
        response.push(error?.response?.data?.data);
      }
      else {
        let jobCard = await getAlgorithmCompletionStatusMultiStage();
         response = await getFailedGroups({
          failed_groups: jobCard.data.failed_groups,
        });
      }

      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: true };
      });

      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(function (
        jobCardDetails
      ) {
        return jobCardDetails.uuid == uuid;
      });

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
        summary: {},
      };

      let jobcardData = {};

      if (!response.length) {
        jobcardData = {
          created_at: detailsList[filteredJobCardIndex].created_at,
          uuid: detailsList[filteredJobCardIndex].uuid,
          id: detailsList[filteredJobCardIndex].id,
          user_id: detailsList[filteredJobCardIndex].user_id,
          updated_at: detailsList[filteredJobCardIndex].updated_at,
          jobcard: {
            group: detailsList[filteredJobCardIndex].jobcard.group,
            solution_1: {
              data: {
                exception:
                  "Job card could not be created for the input.Please check the input and try again",
              },
            },
            solution_2: {
              data: {
                exception:
                  "Job card could not be created for the input.Please check the input and try again",
              },
            },
          },
        };
      } else {
        jobcardData = {
          created_at: response[0].created_at,
          uuid: response[0].uuid,
          id: response[0].id,
          user_id: response[0].user_id,
          updated_at: response[0].updated_at,
          jobcard: {
            group: error?.response?.data?.data?.group_id? response[0] : response[0].group,
            solution_1: { data },
            solution_2: { data },
          },
        };
      }
      jobcardResp.push(jobcardData);
      //set isSucessful to false if the new solution for failedJC is failed
      detailsList[filteredJobCardIndex] = {
        ...detailsList[filteredJobCardIndex],
        isSuccessful: false, 
        newlyCreatedJobCardsDetails :jobcardResp
      };
      setJobCardDetailsList(detailsList);
      if(showAimation[jobIndex])
        setCurrentSolution("3");
      // setSolutionId("3");
      // fetchOrders("current_solution", jobcardData.jobcard);
    } finally {
      setTimeout(() => {
        setShowAimation((prev) => {
          // if it is still pending, keep animation
          const pending = newSolutionPendingParentsRef.current;
          if (pending && pending.has(jobCardId)) return prev;
          return { ...prev, [jobIndex]: false };
        });
      }, 4000);
    }
  };

  /** Navigates back from results: may unselect accepted groups, cancel session, and route by entry type. */
  const routeChange = async () => {
    setStopCancelled(true);
    stopCancellApi.current = true;
    setFormObject(paperMachineFormValues);
    // cancelJobCard();
    let remainingGroups = [];

    if (acceptedJCGrpCode.length > 0) {
      try {
        const res = await unselectGrpOfAcceptedJobcards(acceptedJCGrpCode);
        const resultData = res?.data?.data || [];
        removeGrpsFromOrderSummary(resultData);
        remainingGroups = resultData;
      } catch (err) {
        console.log("API Error:", err);
      }
    }

    if (location?.state?.isDummyJC && location?.state?.type != "replan") {
      if (acceptSolCounter) {
        handleResetAll();
        cancelJobCard();
        history("../job-cards");
      } else {
        handleResetAll();
        cancelJobCard();
        history("../../order-entry/order-details", {
          state: {
            soNumber: location?.state?.so,
            isSo: true,
            dummyOrders: true,
            route: "add-new-so",
          },
        });
      }
    } else if (location?.state?.type === "replan") {
      if (acceptSolCounter) {
        history("../job-cards");
        handleResetAll();
        cancelJobCard();
      } else {
        history("../job-card-details", {
          state: {
            id: location?.state?.parentJCid,
            jobcardType: location?.state?.jobcardType,
          },
        });
        handleResetAll();
        cancelJobCard();
      }
    } else {
      const shouldGoToOrderSummary =
        handleBackPathForJC() &&
        (acceptedJCGrpCode.length > 0
          ? remainingGroups?.groups?.length > 0
          : true);
      if (!shouldGoToOrderSummary) {
        handleResetAll();
        cancelJobCard();
      }

      history(
        shouldGoToOrderSummary ? "../order-summary" : "../create-new-job-cards",
        {
          state: {
            body: location.state.body,
            orderResponse: location.state.orderResponse,
            maximum_burst_factor: location.state.maximum_burst_factor,
            minimum_burst_factor: location.state.minimum_burst_factor,
            maximum_gsm: location.state.maximum_gsm,
            minimum_gsm: location.state.minimum_gsm,
            selected_rewinder: location.state.selected_rewinder,
            selected_cutter: location.state.selected_cutter,
            selected_rewinder_unit: location.state.selected_rewinder_unit,
            selected_cutter_unit: location.state.selected_cutter_unit,
            rewinder_data: location.state.rewinder_data,
            cutter_data: location.state.cutter_data,
            selected_type: location.state.selected_type,
            rewinder_minWidth: location.state.rewinder_minWidth,
            rewinder_maxWidth: location.state.rewinder_maxWidth,
            cutter_minWidth: location.state.cutter_minWidth,
            cutter_maxWidth: location.state.cutter_maxWidth,
            max_NoOfCutters: location.state.max_NoOfCutters,
            minWeight: location.state.minWeight,
            left_edge_trim: location.state.left_edge_trim,
            right_edge_trim: location.state.right_edge_trim,
            // code: location.state.code,
            // machine_code: location.state.code
            code: location.state.code,
            machine_code: location.state.machine_code,
            max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
            left_edge_trim_cutter: location.state.left_edge_trim_cutter,
            right_edge_trim_cutter: location.state.right_edge_trim_cutter,
            processType: location.state.processType,
            initital_OrderType: location.state.initital_OrderType,
          },
        }
      );
    }
  };

  /** Opens the inline "create new solution" panel for the given job card index. */
  const onClickCreateNewSolution = (index) => {
    setCreateNewSolutionClicked(true);
    // history("../create-new-job-cards");
    // history("../create-new-job-cards", {
    //   state: {
    //     jobCards: response.data,
    //     // failed: response.data.failed_groups,
    //     // total_groups: response.data.total_groups
    //   },
    // });
  };
  /** Toggles reel vs sheet visibility in the solution summary area. */
  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "both") {
      setIsJobcardView(true);
      setIsSheetView(true);
    } else if (e.target.value === "reel") {
      setIsJobcardView(true);
      setIsSheetView(false);
    } else {
      setIsJobcardView(false);
      setIsSheetView(true);
    }
  };

  /** Switches order table between grid cards and list/table layout. */
  const handleViewChangeGrid = (e) => {
    setIsTabularView(e.target.value === "list");
  };
   /** Cylinder tab: order-based vs production-based grouping. */
   const handleCylinderViewChange = (e) => {
    if (e.target.value === "production") {
      setCylinderViewData('production');
    } else {
      setCylinderViewData('order');
    }
  }
  const gridViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in grid mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "grid",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in tabular mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="table" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "list",
    },
  ];
  const cylinderMode = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in order mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="order-entry-icon" size={20} color="#EA655B" />
        
      </Tooltip>
    ),
    value: "order",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in production mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="production-icon" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "production",
  },
  
];

  /** Seeds `formValuesForStock[index]` from rewinder/cutter machine limits when not yet populated. */
  const calcStockValues = (key, index) => {
    if (formValuesForStock?.[key]) return;
    const group = jobCardDetailsList[index]?.newlyCreatedJobCardsDetails?.[0]?.jobcard?.group ? jobCardDetailsList[index]?.newlyCreatedJobCardsDetails?.[0]?.jobcard?.group : jobCardDetailsList[index]?.jobcard?.group;
    const rewinderMachine = group?.machines?.find(
      (machine) => machine.machine_type === "rewinder"
    );
    const cutterMachine = group?.machines?.find(
      (machine) => machine.machine_type === "cutter"
    );
    let stockMachineValue = { ...formValuesForStock?.[key] };
    if (rewinderMachine) {
      const {
        deckle_size_lb,
        deckle_size_ub,
        left_edge_trim,
        right_edge_trim,
        original_cutters,
        effective_deckle_length,
        units,
        machine_type,
        machine_code,
      } = rewinderMachine;

      const rightEdgeTrimConversionFactor =
        CoversionFactorUnitsToCM[units.right_edge_trim];
      const deckleSizeUbConversionFactor =
        CoversionFactorCMToUnits[units.deckle_size_ub];

      const minDeckleLength = deckle_size_lb;
      const maxDeckleLength =
        deckle_size_ub +
        (left_edge_trim + right_edge_trim) *
          rightEdgeTrimConversionFactor *
          deckleSizeUbConversionFactor;

      stockMachineValue = {
        ...stockMachineValue,
        min_deckle_length: minDeckleLength,
        max_deckle_length: maxDeckleLength,
        maximum_cutters: original_cutters,
        effective_deckle_length: effective_deckle_length,
        left_edge_trim: left_edge_trim,
        right_edge_trim: right_edge_trim,
        units: units,
      };
    }
    if (cutterMachine) {
      const {
        deckle_size_lb,
        deckle_size_ub,
        left_edge_trim,
        right_edge_trim,
        original_cutters,
        effective_deckle_length,
        max_chop_size,
        min_chop_size,
        maximum_reel_dia,
        minimum_reel_dia,
        allowed_trim,
        units,
        cutters,
      } = cutterMachine;

      const rightEdgeTrimConversionFactor =
        CoversionFactorUnitsToCM[units.right_edge_trim];
      const deckleSizeUbConversionFactor =
        CoversionFactorCMToUnits[units.deckle_size_ub];

      const minDeckleLength = deckle_size_lb;
      const maxDeckleLength =
        deckle_size_ub +
        (left_edge_trim + right_edge_trim) *
          rightEdgeTrimConversionFactor *
          deckleSizeUbConversionFactor;

      stockMachineValue = {
        ...stockMachineValue,
        min_deckle_length_cutter: minDeckleLength,
        max_deckle_length_cutter: maxDeckleLength,
        maximum_cutters_cutter: original_cutters,
        effective_deckle_length_cutter: effective_deckle_length,
        left_edge_trim_cutter: left_edge_trim,
        right_edge_trim_cutter: right_edge_trim,
        min_chop_cutter: min_chop_size,
        max_chop_cutter: max_chop_size,
        min_dia_cutter: minimum_reel_dia,
        max_dia_cutter: maximum_reel_dia,
        units_cutter: units,
        max_trim_intermediate_cutter: allowed_trim,
        cutters_cutter: cutters,
      };
    }
    setFormValuesForStock({ ...formValuesForStock, [index]: stockMachineValue });
  }

  /** Left job-card tab switch: syncs active job card ref and resets summary sub-tabs. */
  const onLeftTabChange = (key) => {    
    setActiveTab('1');
    setCurrentSummaryTab('1');
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    activeJobcardRef.current = parseFloat(key);
    let index = jobCardDetailsList.findIndex(ele => ele.id == key);
    let data = jobcardIdsWithCode[index];
    setActiveJobcard(parseFloat(key));    
    setJobIndex(index);
    setActiveJC(data?.jc_code);
    calcStockValues(parseFloat(key), index)
    currentActiveJC.current = data?.id;
    handleCutterReelDiaChange()
    const nextOrders =
      ordersIdListByJobCard?.[parseFloat(key)] ??
      jobCardDetailsList?.[index]?.jobcard?.group?.orders?.map(
        (order) => order.order_id
      ) ??
      [];
    setStockSizes(stockSizesByJobCard?.[parseFloat(key)] || []);
    setOrderIdList(nextOrders);
  };

  const filterViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding and sheeting plan"}
          className="edit-tooltip"
        >
          <span
            style={{
              transform: "translateY(-5px)",
              color: isJobcardView && isSheetView && "#ea655b",
            }}
          >
            All
          </span>
          {/* <Iconmoon icon="sheet" size={20} color="#EA655B" /> */}
        </Tooltip>
      ),
      value: "both",
    },

    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding plan"}
          className="edit-tooltip"
        >
          <Iconmoon icon="tissue-role" size={18} color="#EA655B" />
        </Tooltip>
      ),
      value: "reel",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View sheeting plan"}
          className="sheet"
        >
          <Iconmoon icon="sheet" size={20} color="#EA655B !important" />
        </Tooltip>
      ),
      value: "sheet",
    },
  ];
  /** Maps intermediate / cutting-pattern API rows into table rows for the Intermediate tab. */
  const getIntermediateListItems = (data) => {
    const tempIntermediateData = data?.map((item, index) => {
      const reelSpecifications = item.diameter_fulfillment?.map((spec) => {
        const outerDiameters = Array.isArray(spec?.reel_od)
          ? spec.reel_od.join(", ")
          : spec.reel_od +
            " " +
            (item.units?.reel_od
              ? lengthUnit[item.units?.reel_od].displayName
              : "cm");
        return `${outerDiameters} / ${spec?.core_id} ${
          item?.units?.core_id
            ? lengthUnit[item?.units?.core_id]?.displayName
            : "cm"
        } (${spec?.fulfilled_weight?.toFixed(3)} ${
          item?.units?.fulfilled_weight
            ? capitalize(weightUnit[item?.units?.fulfilled_weight]?.displayName)
            : "T"
        }, ${spec.fulfilled_reels}R)`;
      });

      const cuttingPattern =
        "(" +
        item.cutting_pattern.partitions.map((item) => item.size).join("+") +
        ") x " +
        item.cutting_pattern.ir_length +
        " " +
        (item.units?.ir_width ? item.units?.ir_width : "cm");
      return {
        key: index,
        srno: index + 1,
        reel_size: `${item.size} ${
          item.units?.size ? lengthUnit[item.units?.size]?.displayName : "cm"
        }`,
        cuttingPattern: cuttingPattern,
        quantity: `${item.fulfilled_weight?.toFixed(3)} ${
          item.units?.fulfilled_weight
            ? capitalize(weightUnit[item.units?.fulfilled_weight]?.displayName)
            : "T"
        }`,
        reelSpecification: reelSpecifications?.join("\n"),
      };
    });
    setIntermediateData(tempIntermediateData);
  };

  /** Populates failed-job orders table from `getFailedGroups` response. */
  const getFailedGroupsData = (response, jobcard) => {
    const failedJobData = response.data?.map((item, index) => {
      return {
        key: index + 1,
        pono: item.po,
        overfulfillmentPercentage:`${( ( (item.fulfilled_weight/item.requirement) -1 )* 100).toFixed(2)}%`,

        category:item?.category,
              sono:item?.so,
        orderno: item.id,
        type: capitalize(item.this_item_type),
        customercode: item.customer,
        customername: item.customer_name,
        customer_alias: item.customer_alias,
        consignee: item.consignee_name,
        matchedGrain: item?.grain,
        productspec: item.product_spec,
        size: `${item.width}${item.length ? ` x ${item.length}` : ""} ${
          lengthUnit[item.units?.width]?.displayName
        }`,
        plannedWeight:
          item.planned_weight +
          " " +
          capitalize(
            item.units?.planned_weight
              ? capitalize(weightUnit[item.units?.planned_weight]?.displayName)
              : "T"
          ),
        unFulflilledWeight:
          item.planned_weight +
          " " +
          capitalize(
            item.units?.planned_weight
              ? capitalize(weightUnit[item.units?.planned_weight]?.displayName)
              : "T"
          ),
        deliverydate: item.category==='so'?"-": moment(item.delivery_date).format("DD MMM YYYY"),
        remarks: item.remarks,
        isReel: item?.type === "reel",
      };
    });
    setFailedJobOrders(failedJobData);
  };

  /** Formats deckle LB–UB range string from rewinder (index 0) or cutter (index 1) machine. */
  function calculateDeckleSize(job, isCylinder, sheet) {
    const machine = sheet
      ? job?.jobcard?.group?.machines[1]
      : job?.jobcard?.group?.machines[0];

    if (machine) {
      const deckleSizeUB = machine.deckle_size_ub || 0;
      const leftEdgeTrim = machine.left_edge_trim || 0;
      const rightEdgeTrim = machine.right_edge_trim || 0;

      const lengthUnitDisplayName =
        lengthUnit[machine.units?.deckle_size_ub]?.displayName || "";

      const totalValue =
        (
          deckleSizeUB +
          (leftEdgeTrim + rightEdgeTrim) *
            CoversionFactorUnitsToCM[machine.units?.right_edge_trim] *
            CoversionFactorCMToUnits[machine.units?.deckle_size_ub]
        );

      const deckleSizeLB = machine.deckle_size_lb || 0;

      let formattedTotalValue;
      if (Number.isInteger(totalValue)) {
        formattedTotalValue = totalValue.toFixed(0); 
      } else {
        formattedTotalValue = totalValue.toFixed(3); 
      }
      let formattedLB = Number.isInteger(deckleSizeLB) ? deckleSizeLB : deckleSizeLB?.toFixed(3);
      return isCylinder
        ? `${formattedLB} - ${formattedTotalValue} ${lengthUnitDisplayName}`
        : `${formattedTotalValue} - ${formattedLB} ${lengthUnitDisplayName}`;
    }

    return "";
}


  /**
   * Loads fulfilled/unfulfilled orders, size rows, cylinders, and intermediate data for the active solution.
   * Drives main tables and `solutionTableData` for the selected job card / solution.
   */
  const fetchOrdersData = async (jobcard, isFailed) => {
    if (!jobcard) return;
    const solId =
      parseFloat(currentSolution) > 2 ? currentSolution - 2 : currentSolution;
      if(currentSolution==='compare') return;
    const isGroupDataRequired =
      isFailed ||
      jobcard[`solution_${solId}`]?.data?.exception ||
      (parseFloat(currentSolution) > 2 && failedNewSol[jobIndex]) ||
      (currentSolution == 1 && jobCardDetailsList[jobIndex]?.isFailedJobcard)
        ? true
        : false;
    const solution = isGroupDataRequired ? undefined : `solution_${solId}`;
    setIsFetchingData(true);
    const sizes = solution ? jobcard[solution]?.data?.sizes : [];
    solution &&
    await  getIntermediateListItems(
        jobcard[`solution_${solId}`]?.data?.intermediate_reels
      );
    let sizeFulfillmentList = sizes?.map((size, index) => {
      return {
        key: index + 1,
        // type: "Order",
        grain: size?.grain && size?.grain !== "None" && size?.grain!=='null' && size?.grain!==null ? size?.grain : "-",
        type: size?.type ? capitalize(size?.type) : "Order",
        size: `${size.size} ${
          size.lateral_size ? "X " + size.lateral_size : ""
        } ${" "} ${
          size.units && size.units.size
            ? lengthUnit[size.units.size]?.displayName
            : "cm"
        }`,
        plannedReels: size.fulfilled + size.unfulfilled,
        plannedWeight:
          (size.fulfilled_weight + size.unfulfilled_weight).toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        fulflilledReels: size.fulfilled,
        fulflilledWeight:
          size.fulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled,
        unFulflilledWeight:
          size.unfulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.unfulfilled_weight
            ? capitalize(weightUnit[size.units.unfulfilled_weight]?.displayName)
            : "T"),
        reelSpecification: size.diameter_fulfillment?.map((diaItem) => {
          const reelOd = diaItem.reel_od;
          const coreId = diaItem.core_id;
          const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
          const fulfilledValue = diaItem.fulfilled;
          const fulfilledWeightUnit = size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size?.units?.fulfilled_weight]?.displayName)
            : "";
          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
            size?.grain && size?.grain != 'null'  && size?.grain !== "None" ? "S" : "R"
          })\n`;
        }),
      };
    });
    setSizesTabData([...sizeFulfillmentList]);

    let ordersList = !isGroupDataRequired
      ? jobcard[solution]?.data.orders
          ?.filter((order) => {
            return order.item_type == "order";
          })
          ?.map((item) => item.order_id)
      : jobcard?.group?.orders
          ?.filter((order) => {
            return order.item_type == "order";
          })
          ?.map((item) => item.order_id);
    const fulfilledOrdersList = solution
      ? jobcard[solution]?.data.orders
          ?.filter((order) => {
            return order.item_type == "order" && order.fulfilled_weight > 0;
          })
          ?.map((item) => item.order_id)
      : jobcard.group.orders
          ?.filter((order) => {
            return order.item_type == "order" && order.fulfilled_weight > 0;
          })
          ?.map((item) => item.order_id);
    const unfulfilledOrdersList = solution
      ? jobcard[solution]?.data.orders
          ?.filter((order) => {
            return order.item_type == "order" && order.unfulfilled_weight > 0;
          })
          ?.map((item) => item.order_id)
      : jobcard.group.orders
          ?.filter((order) => {
            return order.item_type == "order";
          })
          ?.map((item) => item.order_id);
    setTotalFulfilledOrders(fulfilledOrdersList.length);
    setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    let ordersData = [],
      stockData = [];

    let ordersDataForTable =
      currentSummaryTab == 3
        ? [...(ordersList || []).slice(startIndex, endIndex)]
        : [...unfulfilledOrdersList.slice(startIndex, endIndex)];
    ordersList &&
      // getOrdersList([
      //   ...fulfilledOrdersList.slice(startIndex, endIndex),
      //   ...unfulfilledOrdersList.slice(startIndex, endIndex),
      // ])
     await getOrdersList (ordersDataForTable)
      .then((response) => {
          ordersData = !isGroupDataRequired
            ? response.data?.map( (item, index) => {
                const orderData = solution
                  ? jobcard[solution].data.orders.filter(
                      (order) => parseFloat(order.order_id) == item.id
                    )[0]
                  : jobcard.group.orders.filter(
                      (order) => parseFloat(order.order_id) == item.id
                    )[0];

                return {
                  key: index + 1,
                  pono: `${item.po}`,
                  overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )* 100).toFixed(2)}%`,
                  category:item?.category,
              sono:item?.so,
                  orderno: `${item.number}`,
                  type: `Order`,
                  isReel: item?.type === "reel",
                  matchedGrain: item.grain,
                  productspec: item.product_spec,
                  customercode: item.customer,
                  customername: item.customer_name,
                  customer_alias: item.customer_alias,
                  size: `${item.width}${
                    item.length ? ` x ${item.length}` : ""
                  } ${lengthUnit[item.units?.width]?.displayName}`,
                  plannedReels: orderData?.requirement,
                  plannedWeight: solution
                    ? orderData?.requirement?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[orderData?.units?.requirement]?.displayName
                      )
                    : item.planned_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[item.units?.planned_weight]?.displayName
                      ),
                  fulflilledReels: orderData?.fulfilled,
                  fulflilledWeight:
                    orderData?.fulfilled_weight?.toFixed(3) +
                    " " +
                    (orderData?.units?.fulfilled_weight
                      ? capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        )
                      : ""),
                  unFulflilledReels: solution
                    ? orderData?.unfulfilled
                    : orderData?.requirement,
                  unFulflilledWeight: solution
                    ? orderData?.unfulfilled_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[orderData.units?.unfulfilled_weight]
                          ?.displayName
                      )
                    : item.planned_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[item.units?.planned_weight]?.displayName
                      ),
                  priority: item.forced,
                  deliverydate: item.category==='so'?"-": moment(item.delivery_date).format("DD MMM YYYY"),

                  remarks: item.remarks,
                  customer_alias: item.customer_alias,
                  consignee: item.consignee_name,
                  reelSpecification: orderData?.diameter_fulfillment?.map(
                    (diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          ?.displayName
                      );
                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                    }
                  ),
                  cancelledQty:
                    item?.cancelled_quantity?.quantity.toFixed(3) +
                    " " +
                    capitalize(
                      weightUnit[item?.cancelled_quantity?.units]?.displayName
                    ),
                };
              })
            : [];
            let dynamicStockInfo = [];
            let sizesList = [];
          isGroupDataRequired &&   getFailedGroupsData(response, jobcard);
          let isStock = false;
          if (parseFloat(currentSolution) > 0) {
            const stockSizesList = solution
              ? jobcard[solution].data.orders
                  ?.filter((order) => {
                    return (
                      order.item_type == "product_stock_size" &&
                      order.creation_type != "dynamic" &&
                      order.creation_type != "required"
                    );
                  })
                  ?.map((item) => item.order_id)
              : jobcard.group.orders
                  ?.filter((order) => {
                     return (
                      order.item_type == "product_stock_size" &&
                      order.creation_type != "dynamic" &&
                      order.creation_type != "required"
                    );
                  })
                  ?.map((item) => item.order_id);
            isStock = stockSizesList.length;
           
              getStockSizesDetailsByIds({ stock_sizes: stockSizesList })
                .then((response) => {
                   sizesList = [
                    ... response.data?.map((item, index) => {
                    const orderData = solution
                      ? jobcard[solution].data.orders.filter(
                          (order) => order.order_id === item.id
                        )[0]
                      : jobcard.group.orders.filter(
                          (order) => order.order_id === item.id
                        )[0];

                    return {
                      key: index + 1,
                      pono: "-",
                      overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )* 100).toFixed(2)}%`,
                      orderno: `${item.id}`,
                      type: "Stock",
                      productspec: item.product_spec,
                      customercode: "-",
                      customername: "-",
                      size: `${item.width}${
                        item.length ? ` x ${item.length}` : ""
                      } ${lengthUnit[item.units?.width]?.displayName}`,
                      plannedReels: "-",
                      plannedWeight: "-",
                      fulflilledReels: orderData.fulfilled,
                      fulflilledWeight:
                        orderData.fulfilled_weight?.toFixed(3) +
                        " " +
                        (orderData.units?.fulfilled_weight
                          ? capitalize(
                              weightUnit[orderData.units?.fulfilled_weight]
                                ?.displayName
                            )
                          : ""),
                      unFulflilledReels: "-",
                      unFulflilledWeight: "-",
                      priority: false,
                      deliverydate: "-",
                      remarks: "-",
                      consignee: item.consignee_name,
                      reelSpecification: orderData?.diameter_fulfillment?.map(
                        (diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[orderData.units?.fulfilled_weight]
                              ?.displayName
                          );
                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                        }
                      ),
                      isReel: item?.type==='reel',
                    };
                  })];


              

                  let dynamicStock = jobcard[solution]?.data?.orders?.filter(
                    (order) => {
                      return (
                        order.creation_type == "dynamic" ||
                        order.creation_type == "required"
                      );
                    }
                  );
                  if ( dynamicStock &&dynamicStock.length) {
                    dynamicStockInfo = [
                      ...dynamicStock?.map((item, index) => {
                        // console.log(orderData);
                        return {
                          key: index + 1,
                          pono: "-",
                          overfulfillmentPercentage:`${( ( (item.fulfilled_weight/item.requirement) -1 )* 100).toFixed(2)}%`,
                          orderno: `-`,
                          type: "Stock",
                          productspec: jobcard.group.product.product_spec,
                          customercode: "-",
                          customername: "-",
                    size:
                  item.type === "reel"
                    ? +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase()
                    : +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase() + " * " + +item.lateral_size + ' ' + lengthUnit[item.units.lateral_size].displayName.toUpperCase(),
            
                          plannedReels: "-",
                          plannedWeight: "-",
                          fulflilledReels: item.fulfilled,
                          fulflilledWeight:
                            item.fulfilled_weight?.toFixed(3) +
                            " " +
                            (item.units?.fulfilled_weight
                              ? capitalize(
                                  weightUnit[item.units?.fulfilled_weight]
                                    ?.displayName
                                )
                              : ""),
                          unFulflilledReels: "-",
                          unFulflilledWeight: "-",
                          priority: false,
                          deliverydate: "-",
                          remarks: "-",
                          consignee: "-",
                          reelSpecification: item?.diameter_fulfillment?.map(
                            (diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[item.units?.fulfilled_weight]
                                  ?.displayName
                              );
                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                            }
                          ),
                          isReel: item?.type==='reel',
                        };
                      }),
                    ];
                  }

                })
                .catch((err) => console.log(err))
                .finally(() => {
                  const tempSolutionData =
                    parseFloat(currentSolution) > 2
                      ? [...ordersData, ...sizesList, ...dynamicStockInfo]
                      : [...ordersData, ...sizesList, ...dynamicStockInfo];
                  //setTimeout(() => {
                    setSolutionTableData([...tempSolutionData]);
                   // setIsFetchingData(false)
                 /// }, 100);
                });
          }
          if (!isStock) {
            const tempSolutionData =
              parseFloat(currentSolution) > 2
                ? [...ordersData, ...sizesList, ...dynamicStockInfo]
                : [...ordersData, ...sizesList, ...dynamicStockInfo];
               // setTimeout(() => {
                  setSolutionTableData([...tempSolutionData]);
                 // setIsFetchingData(false)
                //}, 100);        
                }
        })
        .catch((error) => console.log(error))
        .finally(() => setIsFetchingData(false));

    let tempOrdersArray = [];
    jobcard?.group?.orders?.map((order) => {
      tempOrdersArray.push(order.order_id);
    });
    if (selectedJobCardId) {
      setOrdersIdListByJobCard((prev) => {
        if (prev[selectedJobCardId] !== undefined) {
          return prev;
        }
        return {
          ...prev,
          [selectedJobCardId]: tempOrdersArray,
        };
      });
      const currentOrdersForJobCard =
        ordersIdListByJobCard?.[selectedJobCardId] ?? tempOrdersArray;
      setOrderIdList([...(currentOrdersForJobCard || [])]);
    } else {
      setOrderIdList([...tempOrdersArray]);
    }
  };

  /** Opens the order detail drawer for a row in the fulfillment tables. */
  const showViewDrawer = (value,record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record)
    setViewOrder(true);
  };

  const orderFulfillmentColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);
      
        return (
          <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
            {value
              ?.match(/.{1,15}/g)
              ?.map((chunk, index) => (
                <span key={index}>
                  {chunk}
                  <br />
                </span>
              ))}
          </span>
        );
      }
      

    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
   
  
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },

    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "10%",
      render: (text, record) => (!record.isReel ? <div>{text}</div> : "-"),
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
        title: "Overfulfilment %",
        dataIndex: "overfulfillmentPercentage",
        width: "10%",
      },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text, record) =>
        ( record.isReel && text ) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
   
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "9%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno,record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];
  const intermediateColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "srno",
      width: 6,
      fixed: "left",
      align: "center",
    },
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: 8,
      // fixed: "left",
      align: "center",
    },
    {
      title: "Cutting Pattern",
      dataIndex: "cuttingPattern",
      width: 10,
      align: "center",
    },
    // {
    //   title: "",
    //   dataIndex: "grain",
    //   width: 8,
    //   align: "center",
    // },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 8,
      align: "center",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: 16,
      align: "center",
      render: (text) => (
        (  text ) ? <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        /> : '-'
      ),
    },
  ];

  const unfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
            ? toHandlePOName(record.sono)
            : toHandlePOName(record.pono);
      
        return (
          <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
            {value
              ?.match(/.{1,15}/g)
              ?.map((chunk, index) => (
                <span key={index}>
                  {chunk}
                  <br />
                </span>
              ))}
          </span>
        );
      }
      

    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias||'-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: "10%",
      render: (text, record) => (
        record?.consignee||'-'
      )
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "8%",
      render: (text, record) => `${!record.isReel ? text : "-"}`,
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text, record) =>
       ( record.isReel && text )? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQty",
      width: "8%",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "9%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno,record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "10%",
      // render: (record, text) => (
      //   record.type == 'Sheet' ?
      // )
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "UnFulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text, record) =>
        ( text && record.type === "Order" )? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
  ];

  //  const orderFulfillmentColumnsHead = [
  //     {
  //       title: "Po/So.No",
  //       dataIndex: "pono",
  //       width: "8%",
  //       fixed: "left",
  //       align: "center",
  //       render: (text, record) => {
  //         const value =
  //           record.category === "po"
  //             ? toHandlePOName(record.pono)
  //             : record.category === "so"
  //             ? toHandlePOName(record.sono)
  //             : toHandlePOName(record.pono);
  
  //         return (
  //           <span
  //             style={{
  //               whiteSpace: "normal",
  //               wordBreak: "break-word",
  //               lineHeight: "1.4",
  //             }}
  //           >
  //             {value?.match(/.{1,15}/g)?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //           </span>
  //         );
  //       },
  //     },
  //     {
  //       title: "Order No/Stock No",
  //       dataIndex: "orderno",
  //       width: "10%",
  //       fixed: "left",
  //     },
  //     {
  //       title: (
  //         <div>
  //           Product Spec
  //           <Styled style={{ display: "inline-flex" }}>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={`The product specification is in the ${format}`}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <span className="infoIcon"></span>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //       dataIndex: "productspec",
  //       width: "14%",
  //     },
  //     {
  //       title: "Size(WxL)",
  //       dataIndex: "size",
  //       width: "9%",
  //     },
  //     {
  //       title: "Planned Quantity",
  //       dataIndex: "plannedWeight",
  //       width: "10%",
  //     },
  //     {
  //       title: "Fulfilled Quanitity",
  //       dataIndex: "fulflilledWeight",
  //       width: "10%",
  //     },
  //     {
  //       title: "Overfulfilment %",
  //       dataIndex: "overfulfillmentPercentage",
  //       width: "10%",
  //     },
  //     {
  //       title: "REEL SPECIFICATION",
  //       dataIndex: "reelSpecification",
  //       width: "22%",
  //       render: (text) => (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html: String(text).replace(/\n/g, "<br />"),
  //           }}
  //         />
  //       ),
  //     },
  //     {
  //       title: "Remarks",
  //       dataIndex: "remarks",
  //       width: "10%",
  //       render: (text, record) =>
  //         record.type === "Order" && (
  //           <div className="actionBtn">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={record.remarks}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button style={{ cursor: "default" }}>
  //                   <Iconmoon icon="message" size={16} color="#EA655B" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         ),
  //       align: "center",
  //     },
  //     {
  //       title: "Actions",
  //       dataIndex: "action",
  //       width: "10%",
  //       render: (text, record) =>
  //         record.type === "Order" && (
  //           <div className="actionBtn">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"View details of this order"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button onClick={() => showViewDrawer(record.orderno, record)}>
  //                   <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         ),
  //       align: "center",
  //     },
  //   ];

  /** Renders the right-hand solution tabs (summary, orders, sizes, cylinders, etc.) for one job card. */
  const leftJobcardTabBody = (job, jobInd) => {
    const jobcardSolutionList = [];

    if (job?.jobcard?.solution_1) jobcardSolutionList.push(1);
    if (job?.jobcard?.solution_2 && !job?.isFailedJobcard)
      jobcardSolutionList.push(2);

    if (
      job?.newlyCreatedJobCardsDetails &&
      job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1
    )
      jobcardSolutionList.push(3);
    if (
      job?.newlyCreatedJobCardsDetails &&
      !failedNewSol[jobIndex] &&
      job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2
    )
      jobcardSolutionList.push(4);
    let solId = currentSolution;
    // if (job?.isFailedJobcard) solId = -1;
    if (parseFloat(currentSolution) > 2) solId = solId - 2;
    if (!job || !solId) return;
    const jobcardData =
      parseFloat(currentSolution) > 2 && job?.newlyCreatedJobCardsDetails
        ? job?.newlyCreatedJobCardsDetails[0]
        : job;
    job = jobcardData;
    return (
      <Tabs
        className="tabPostTab"
        defaultActiveKey={currentSolution}
        onChange={(activekey) => {
          setActiveTab("1");
          setSizeExpanded(false);
          setSizeExpanded(false);
          setSizeExpanded(false);
          setSizeExpanded(false);
          setCurrentSolution(activekey);
        }}
        activeKey={currentSolution}
        tabBarExtraContent={
          !(
            jobCardDetailsList[jobIndex]?.jobcard?.solution_1?.status ===
              "accept" ||
            jobCardDetailsList[jobIndex]?.jobcard?.solution_2?.status ===
              "accept" ||
            (jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails &&
              jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0]
                .jobcard?.solution_1?.status === "accept") ||
            (jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails &&
              jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0]
                .jobcard?.solution_2?.status === "accept")
          ) &&
          ordersIdList.length > 0 &&
          currentSolution !== "compare" && (
            <Button
              key="5"
              className="textTypeBtn"
              onClick={() => onClickCreateNewSolution()}
              // disabled={!userDetails.roles.job_cards.edit}
              style={{ marginBottom: "3px" }}
            >
              <Iconmoon
                icon="addcircle"
                size={14}
                color="#ea655b"
                style={{
                  paddingTop: "2px",
                  marginRight: "3px",
                }}
              />
              Create New Solution
            </Button>
          )
        }
      >
        {/* Compare solution tab */}
        {
          <TabPane key={"compare"} tab="Compare Solution">
            <SolutionContainer>
              {/* <div className="MatchResult"> */}
              <CreateNewSolCompare
                summary={compareSolSummaryData}
                newSummaryData={newCompareSolSummaryData}
                onAccept={acceptModalShow}
                setSolutionId={setCurrentSolution}
                jobIndex={jobIndex}
                isMultistage={true}
              />
              {/* </div> */}
            </SolutionContainer>
          </TabPane>
        }
        {/* {jobcardSolutionList.map((solId) => ( */}
        {(!jobCardDetailsList[jobIndex]?.isFailedJobcard ||
          (jobCardDetailsList[jobIndex]?.isFailedJobcard &&
            !jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails
              ?.length)) && (
          <TabPane
            key={"1"}
            tab={
              jobCardDetailsList[jobIndex]?.isFailedJobcard
                ? "Failed Solution"
                : `Solution 1`
            }
          >
            <SolutionContainer>
              {job?.isFailedJobcard ? (
                <>
                  <PageTitleComp style={{ borderBottom: "0" }}>
                    <PageHeader ghost={false} title="Job Card "></PageHeader>
                  </PageTitleComp>
                  <div className="MatchResult">
                    <Row span={24} className="pipeBlockCylinder">
                      {((!sizeExpanded && activeTab == "2") ||
                        (!sizeExpanded && activeTab == "3") ||
                        (!sizeExpanded && activeTab == "4") ||
                        (!sizeExpanded && activeTab == "5") ||
                        activeTab == "1") && (
                        <Col
                          span={15}
                          className="pipeBlock"
                          style={{ paddingRight: "20px" }}
                        >
                          <RightSideSolution>
                            <div className="deckleCoverImage">
                              <img
                                src={deckleCover}
                                alt="deckle match result"
                              />
                            </div>
                            <div className="colLayoutBlock deckleErrorLayout">
                              <p style={{ color: "#EA655B" }}>
                                Job card could not be created for the input.
                                Please check the input and try again
                              </p>
                            </div>{" "}
                          </RightSideSolution>
                        </Col>
                      )}
                      <Col
                        span={
                          ((sizeExpanded && activeTab == "2") ||
                            (sizeExpanded && activeTab == "3") ||
                            (sizeExpanded && activeTab == "4") ||
                            (sizeExpanded && activeTab == "5")) &&
                          activeTab != "1"
                            ? 24
                            : 9
                        }
                        className="colLayoutBlock"
                      >
                        <Tabs
                          defaultActiveKey={currentSummaryTab}
                          activeKey={currentSummaryTab}
                          className="topPostTab innerPostTab"
                          onChange={(key) => {
                            setCurrentSummaryTab(key);
                            setActiveTab(key);
                          }}
                        >
                          <Panes
                            tab="Summary"
                            key="1"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <Collapse
                              className="sub-category"
                              expandIconPosition="right"
                              defaultActiveKey={["1", "2", "3", "4"]}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CollapsePanel
                                key="1"
                                header="General Information"
                              >
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={11}>
                                    {" "}
                                    <span>Product Specifications</span>
                                    <p
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {job.jobcard?.group?.product.product_spec}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Priority Quantity</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.forced_requirement_fulfilled
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.forced_requirement.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.forced_requirement
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .forced_requirement
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                </Row>
                              </CollapsePanel>

                              <CollapsePanel key="2" header="Paper Machine">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Paper Machine</span>
                                    <p>{job.jobcard.group.machines[0].name}</p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Deckle Width</span>
                                    <p>{calculateDeckleSize(job)}</p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="3" header="Rewinding">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Rewinding Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.net_rewinding_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.net_rewinding_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.net_rewinding_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .net_rewinding_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.rewinding_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.rewinding_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.rewinding_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Rewinder</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "rewinder",
                                        )[0]?.rewinder_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary
                                        ?.rewinder_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.rewinder_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.rewinder_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .rewinder_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.unique_rewinding_partitions
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.unique_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.total_rewinding_partitions
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.total_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="4" header="Cutting">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Cutting Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.net_cutting_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.net_cutting_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.net_cutting_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .net_cutting_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.cutting_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.cutting_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.cutting_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .cutting_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Cutter</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "cutter",
                                        )[0]?.cutter_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary
                                        ?.cutting_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.cutting_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.cutting_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .cutting_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.unique_cutting_patterns
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.unique_cutting_patterns
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.total_cutting_partitions
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.total_cutting_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                            </Collapse>
                          </Panes>
                          <Panes
                            tab={
                              <span>
                                Unfulfilled Orders
                                {activeTab == "2" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="2"
                            // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                {isFetchingData ? (
                                  <TableShimmer
                                    header={unfulfilledColumnsHead}
                                    scroll={1300}
                                  />
                                ) : (
                                  <Table
                                    columns={unfulfilledColumnsHead}
                                    dataSource={failedJobOrders}
                                    onChange={(pagination) =>
                                      onChange(pagination, true)
                                    }
                                    scroll={{ x: 1800 }}
                                    rowClassName={(record) =>
                                      record.priority && "true"
                                    }
                                    pagination={{
                                      current: currentPage,
                                      pageSize: pageSize,
                                      total: totalUnfulfilledOrders,
                                      onChange: onPaginationChange,
                                      showSizeChanger: true,
                                      showQuickJumper: true,
                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    }}
                                  />
                                )}
                              </div>
                            </TableLayoutData>
                          </Panes>
                        </Tabs>
                      </Col>
                    </Row>
                  </div>
                </>
              ) : (
                <>
                  <PageTitleComp style={{ borderBottom: "0", padding: "0" }}>
                    <PageHeader
                      ghost={false}
                      title={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "50px",
                          }}
                        >
                          <span>
                            {job.state == "pending"
                              ? activeJC
                              : "Job Card " + activeJC}
                          </span>
                          {/* {job.state == "pending" ? (
                            (activeJC?.length > 20 ? (
                              <Tooltip placement="bottomLeft" title={activeJC}>
                                {activeJC?.slice(0,21)+"..."}
                              </Tooltip>
                              ) : (
                                activeJC
                            ))
                            ) : (
                            ("Job Card " + activeJC)
                            )
                          } */}
                        </div>
                      }
                      extra={
                        <div
                          className="extrasContainer"
                          style={{ display: "flex" }}
                        >
                          {!job.jobcard[`solution_${1}`].data.exception && [
                            job.jobcard[`solution_${1}`].status === "accept" ? (
                              <AlertContainer
                                color="green"
                                icon={alertGreen}
                                msg="The solution is sent for approval"
                              />
                            ) : job.jobcard[`solution_${1}`].status ===
                              "reject" ? (
                              job.jobcard[`solution_${1 == 1 ? "2" : "1"}`]
                                .status === "accept" ? (
                                <AlertContainer
                                  color="green"
                                  icon={alertGreen}
                                  msg={`The${
                                    isSolutionAccepted > 2 ? " new" : ""
                                  } solution ${
                                    isSolutionAccepted == 2 ||
                                    isSolutionAccepted == 4
                                      ? "2"
                                      : "1"
                                  } is already accepted`}
                                />
                              ) : (
                                <AlertContainer
                                  color={isSolutionAccepted ? "green" : "red"}
                                  icon={
                                    isSolutionAccepted ? alertGreen : alertRed
                                  }
                                  msg={
                                    isSolutionAccepted > 2
                                      ? `The new solution ${
                                          isSolutionAccepted - 2
                                        } is already accepted`
                                      : isSolutionAccepted
                                        ? `The solution ${isSolutionAccepted} is already accepted`
                                        : "The solution is discarded by the user"
                                  }
                                />
                              )
                            ) : (
                              <RightSideSolution>
                                {!(
                                  parseFloat(currentSolution) > 2 &&
                                  failedNewSol[jobIndex]
                                ) && (
                                  <div className="rightSideSolutionButtons">
                                    <Button
                                      key="1"
                                      className="themeBtn noBg"
                                      onClick={() =>
                                        discardModalShow("solution1")
                                      }
                                      disabled={
                                        !userDetails.roles.job_cards.edit
                                      }
                                      loading={isDiscardLoading}
                                    >
                                      {!isDiscardLoading && (
                                        <Iconmoon
                                          icon="wrong"
                                          size={14}
                                          color="#EA4E2C"
                                        />
                                      )}
                                      Discard Solution
                                    </Button>
                                    <Button
                                      key="2"
                                      className="themeBtn"
                                      onClick={() =>
                                        acceptModalShow("solution1")
                                      }
                                      disabled={
                                        !userDetails.roles.job_cards.edit
                                      }
                                      loading={isAcceptLoading}
                                    >
                                      {!isAcceptLoading && (
                                        <Iconmoon
                                          icon="correct"
                                          size={14}
                                          color="#ffffff"
                                        />
                                      )}
                                      Accept Solution
                                    </Button>
                                  </div>
                                )}
                              </RightSideSolution>
                            ),
                          ]}
                        </div>
                      }
                      style={{ marginBottom: "10px", height: "50px" }}
                    />
                  </PageTitleComp>
                  <div className="MatchResult">
                    <Row span={24} className="pipeBlockCylinder">
                      {((!sizeExpanded && activeTab == "2") ||
                        (!sizeExpanded && activeTab == "3") ||
                        (!sizeExpanded && activeTab == "4") ||
                        (!sizeExpanded && activeTab == "5") ||
                        activeTab == "1") && (
                        <Col
                          span={15}
                          className="pipeBlock"
                          style={{ paddingRight: "20px" }}
                        >
                          {" "}
                          <RightSideSolution>
                            {!jobcardData?.jobcard[`solution_${1}`]?.data
                              ?.exception &&
                            !(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) ? (
                              // jobCardDetailsList &&
                              <>
                                <div>
                                  <div
                                    className="radioSwitchStyle"
                                    style={{
                                      zIndex: 10,
                                      display: "flex",
                                      flexDirection: "row-reverse",
                                      gap: "20px",
                                      transform: "translateY(-50px)",
                                    }}
                                  >
                                    <div className="table-view">
                                      <HaberForm>
                                        <RadioButtonStyle1>
                                          <div
                                            className="boxFormType switchRadio"
                                            style={{
                                              // justifyContent: "flex-end",
                                              display: "flex",
                                              // paddingRight: "",
                                              // transform: "translate(-225px,-15px)",
                                              // position: "absolute",
                                              // width: "200px",
                                            }}
                                          >
                                            <Radio.Group
                                              options={filterViewData}
                                              onChange={handleViewChange}
                                              value={
                                                isJobcardView && isSheetView
                                                  ? "both"
                                                  : isJobcardView
                                                    ? "reel"
                                                    : "sheet"
                                              }
                                              optionType="button"
                                              buttonStyle="1"
                                              className={
                                                isSheetView && isJobcardView
                                                  ? "allActive"
                                                  : isSheetView
                                                    ? "sheetActive"
                                                    : "jcActive"
                                              }
                                            />
                                          </div>
                                        </RadioButtonStyle1>
                                      </HaberForm>
                                    </div>
                                    <div className="table-view">
                                      <HaberForm>
                                        <RadioButtonStyle1>
                                          <div
                                            className="boxFormType switchRadio"
                                            style={{
                                              justifyContent: "flex-end",
                                              display: "flex",
                                              columnGap: "10px",
                                            }}
                                          >
                                            <Radio.Group
                                              options={cylinderMode}
                                              onChange={
                                                handleCylinderViewChange
                                              }
                                              value={cylinderViewData}
                                              optionType="button"
                                              buttonStyle="solid"
                                              className={
                                                cylinderViewData ===
                                                "production"
                                                  ? "ListViewActive"
                                                  : "gridViewActive"
                                              }
                                            />
                                            <Radio.Group
                                              options={gridViewData}
                                              onChange={handleViewChangeGrid}
                                              value={isTabularView}
                                              optionType="button"
                                              buttonStyle="1"
                                              className={
                                                !isTabularView
                                                  ? "gridViewActive"
                                                  : "ListViewActive"
                                              }
                                            />
                                          </div>
                                        </RadioButtonStyle1>
                                      </HaberForm>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: isJobcardView ? "block" : "none",
                                    padding: "0px",
                                    margin: "0px",
                                    transform: "translateY(-50px)",
                                  }}
                                >
                                  <JobCardCylinderContainerMultistage
                                    jobId={job?.id}
                                    solution={1}
                                    multiView={true}
                                    deckle_match_page={true}
                                    // style={{width:'80%'}}
                                    deckleSize={calculateDeckleSize(
                                      jobcardData,
                                      true,
                                    )}
                                    solId={1}
                                    rewinderName={`${
                                      jobcardData?.jobcard?.group.machines?.find(
                                        (item) =>
                                          item.machine_type !== "cutter",
                                      )?.rewinder_name
                                    }`}
                                    isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}
                                    
                                    currentCylinderData={currentCylinderData}
                                  />
                                </div>
                                {isSheetView && (
                                  <>
                                    <SheetJobCardCylinderContainerMultistage
                                      jobId={job?.id}
                                      solution={1}
                                      multiView={false}
                                      acceptedSolution={
                                        jobcardData?.jobcard[`solution_${1}`]
                                      }
                                      jobCard={job.jobcard}
                                      // print_function={
                                      //   orderDetailsList ? printJobCardDetails : null
                                      // }
                                      unitData={unitData}
                                      isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                      currentSolution={currentSolution}
                                    />
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <div className="deckleCoverImage">
                                  <img
                                    src={deckleCover}
                                    alt="deckle match result"
                                  />
                                </div>
                                {/* Exception message */}
                                <div className="colLayoutBlock deckleErrorLayout">
                                  <p style={{ color: "#EA655B" }}>
                                    {!(
                                      parseFloat(currentSolution) > 2 &&
                                      failedNewSol[jobIndex]
                                    )
                                      ? jobcardData?.jobcard[`solution_${1}`]
                                          ?.data?.exception
                                      : "Job card could not be created for the input. Please check the input and try again"}
                                  </p>
                                </div>
                              </>
                            )}
                          </RightSideSolution>
                        </Col>
                      )}
                      <Col
                        span={
                          ((sizeExpanded && activeTab == "2") ||
                            (sizeExpanded && activeTab == "3") ||
                            (sizeExpanded && activeTab == "4") ||
                            (sizeExpanded && activeTab == "5")) &&
                          activeTab != "1"
                            ? 24
                            : 9
                        }
                        className="colLayoutBlock"
                      >
                        {solutionTableData ? (
                          <Tabs
                            defaultActiveKey={activeTab}
                            activeKey={activeTab}
                            className="topPostTab innerPostTab"
                            onChange={(key) => {
                              onPaginationChange(1, 10);
                              setCurrentSummaryTab(key);
                              setActiveTab(key);
                            }}
                          >
                            <Panes
                              tab={`Solution ${1} summary`}
                              key="1"
                              // disabled={solutionSummary?.solution1.exception}
                            >
                              <div className="lossValue">
                                {!jobcardData?.jobcard[`solution_${1}`]?.data
                                  ?.exception &&
                                  !(
                                    parseFloat(currentSolution) > 2 &&
                                    failedNewSol[jobIndex]
                                  ) && (
                                    <>
                                      <Row span={24}>
                                        <Col span={12}>
                                          <div className="summaryValue">
                                            <h5>
                                              <span className="trimCut"></span>{" "}
                                              Trim Loss
                                            </h5>
                                            <span>
                                              {`${job?.jobcard[
                                                `solution_${1}`
                                              ]?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                                3,
                                              )} %`}
                                            </span>
                                            {
                                              (jobcardData?.jobcard
                                                ?.comparison?.[
                                                matchTrimLossKey
                                              ] > 0 &&
                                                1 % 2 == 1) ||
                                              (jobcardData?.jobcard
                                                ?.comparison?.[
                                                matchTrimLossKey
                                              ] < 0 &&
                                                1 % 2 == 0) ? (
                                                <span className="lesserSolution">
                                                  <img
                                                    src={greaterRange}
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    alt=""
                                                  />
                                                  {jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ]
                                                    ? Math.abs(
                                                        jobcardData?.jobcard
                                                          ?.comparison?.[
                                                          matchTrimLossKey
                                                        ],
                                                      )?.toFixed(3)
                                                    : 0}{" "}
                                                  % pts greater than{" "}
                                                  {1 % 2 == 0 ? "1" : "2"}
                                                </span>
                                              ) : (
                                                <span className="lesserSolution">
                                                  <img
                                                    src={lowerRange}
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    alt=""
                                                  />
                                                  {jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ]
                                                    ? Math.abs(
                                                        jobcardData?.jobcard
                                                          ?.comparison?.[
                                                          matchTrimLossKey
                                                        ],
                                                      )?.toFixed(3)
                                                    : 0}{" "}
                                                  % pts lesser than{" "}
                                                  {1 % 2 == 0 ? "1" : "2"}
                                                </span>
                                              )
                                              // ) : (
                                              //   <></>
                                              // )
                                            }
                                          </div>
                                        </Col>
                                        <Col span={12}>
                                          <div className="summaryValue">
                                            <h5>
                                              <span className="trimBox"></span>{" "}
                                              Fulfillment
                                            </h5>
                                            <span>
                                              {`${jobcardData?.jobcard[
                                                `solution_${1}`
                                              ]?.data?.summary?.weight_requirement_fulfilled_percentage?.toFixed(
                                                3,
                                              )} %`}
                                            </span>
                                            {
                                              // jobcardData?.jobcard[`solution_${1}`]?.data?.summary
                                              //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                              (jobcardData?.jobcard
                                                ?.comparison?.[
                                                matchFulfilmentKey
                                              ] > 0 &&
                                                1 % 2 == 1) ||
                                              (jobcardData?.jobcard
                                                ?.comparison?.[
                                                matchFulfilmentKey
                                              ] < 0 &&
                                                1 % 2 == 0) ? (
                                                <span className="lesserSolution">
                                                  <img
                                                    src={greaterRange}
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    alt=""
                                                  />
                                                  {jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ]
                                                    ? Math.abs(
                                                        jobcardData?.jobcard
                                                          ?.comparison?.[
                                                          matchFulfilmentKey
                                                        ],
                                                      )?.toFixed(3)
                                                    : 0}{" "}
                                                  % pts greater than{" "}
                                                  {1 % 2 == 0 ? "1" : "2"}
                                                </span>
                                              ) : (
                                                <span className="lesserSolution">
                                                  <img
                                                    src={lowerRange}
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    alt=""
                                                  />
                                                  {jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ]
                                                    ? Math.abs(
                                                        jobcardData?.jobcard
                                                          ?.comparison?.[
                                                          matchFulfilmentKey
                                                        ],
                                                      )?.toFixed(3)
                                                    : 0}{" "}
                                                  % pts lesser than{" "}
                                                  {1 % 2 == 0 ? "1" : "2"}
                                                </span>
                                              )
                                              // ) : (
                                              //   <></>
                                              // )
                                            }
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row span={24}>
                                        <Col span={12}>
                                          <div className="summaryValue">
                                            <h5>
                                              <span className="trimCut"></span>{" "}
                                              Net Trim Loss:{" "}
                                              {jobcardData?.jobcard[
                                                `solution_${1}`
                                              ]?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                                3,
                                              )}{" "}
                                              %<p>Loss including edge trim</p>
                                            </h5>
                                          </div>
                                        </Col>
                                        <Col span={12}>
                                          <div className="summaryValue">
                                            <h5>
                                              <span className="trimBox"></span>{" "}
                                              Weight:{" "}
                                              {jobcardData?.jobcard[
                                                `solution_${1}`
                                              ].data.summary.job_card_weight?.toFixed(
                                                3,
                                              )}{" "}
                                              {capitalize(
                                                weightUnit[
                                                  job.jobcard[`solution_${1}`]
                                                    .data.summary.units
                                                    ?.job_card_weight
                                                ]?.displayName,
                                              )}
                                              <p className="lesserSolution">
                                                Total weight of Job Card
                                              </p>
                                            </h5>
                                          </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                <Row span={24}>
                                  {/* <div className="sub-category"> */}

                                  <Collapse
                                    className="sub-category"
                                    expandIconPosition="right"
                                    defaultActiveKey={["1", "2", "3", "4"]}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <CollapsePanel
                                      key="1"
                                      header="General Information"
                                    >
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <Col span={11}>
                                          {" "}
                                          <span>Product Specifications</span>
                                          <p
                                            style={{
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            {
                                              job.jobcard?.group?.product
                                                .product_spec
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Priority Quantity</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary
                                              ?.forced_weight_requirement
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.forced_weight_requirement.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.forced_weight_requirement
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .forced_weight_requirement
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                      </Row>
                                    </CollapsePanel>

                                    <CollapsePanel
                                      key="2"
                                      header="Paper Machine"
                                    >
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Paper Machine</span>
                                          <p>
                                            {job.jobcard.group.machines[0].name}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Deckle Width</span>
                                          <p>{calculateDeckleSize(job)}</p>
                                        </Col>{" "}
                                      </Row>{" "}
                                    </CollapsePanel>
                                    <CollapsePanel key="3" header="Rewinding">
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Net Rewinding Qty</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.net_rewinding_quantity
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.net_rewinding_quantity.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.net_rewinding_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .net_rewinding_quantity
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Trim Loss</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.rewinding_net_trim_loss
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.rewinding_net_trim_loss.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.rewinding_net_trim_loss
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .rewinding_net_trim_loss
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Rewinder</span>{" "}
                                          <p>
                                            {
                                              job.jobcard?.group.machines?.filter(
                                                (item) =>
                                                  item.machine_type ===
                                                  "rewinder",
                                              )[0]?.rewinder_name
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Processed Order Qty</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary
                                              ?.rewinder_processed_order_quantity
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.rewinder_processed_order_quantity.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.rewinder_processed_order_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .rewinder_processed_order_quantity
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Number of Unique Sets</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary
                                              ?.unique_rewinding_partitions
                                              ? job.jobcard[`solution_${1}`]
                                                  .data.summary
                                                  .unique_rewinding_partitions
                                              : 0}{" "}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Total Number of Sets</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary
                                              ?.total_rewinding_partitions
                                              ? job.jobcard[`solution_${1}`]
                                                  .data.summary
                                                  .total_rewinding_partitions
                                              : 0}{" "}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                    </CollapsePanel>
                                    <CollapsePanel key="4" header="Cutting">
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Net Cutting Qty</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.net_cutting_quantity
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.net_cutting_quantity.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.net_cutting_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .net_cutting_quantity
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Trim Loss</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.cutting_net_trim_loss
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.cutting_net_trim_loss.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.cutting_net_trim_loss
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .cutting_net_trim_loss
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Cutter</span>{" "}
                                          <p>
                                            {
                                              job.jobcard?.group.machines?.filter(
                                                (item) =>
                                                  item.machine_type ===
                                                  "cutter",
                                              )[0]?.cutter_name
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Processed Order Qty</span>
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary
                                              ?.cutting_processed_order_quantity
                                              ? job.jobcard[
                                                  `solution_${1}`
                                                ].data.summary.cutting_processed_order_quantity.toFixed(
                                                  3,
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.units
                                              ?.cutting_processed_order_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[`solution_${1}`]
                                                      .data.summary?.units
                                                      .cutting_processed_order_quantity
                                                  ]?.displayName,
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Number of Unique Sets</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${1}`]?.data
                                              ?.summary?.unique_cutting_patterns
                                              ? job.jobcard[`solution_${1}`]
                                                  .data.summary
                                                  .unique_cutting_patterns
                                              : 0}{" "}
                                          </p>
                                        </Col>
                                        {/* <Col span={11}>
                              <span>Total Number of Sets</span>
                              <p>
                                {job.jobcard[`solution_${1}`]?.data?.summary
                                  ?.total_cutting_partitions
                                  ? job.jobcard[`solution_${1}`].data
                                      .summary.total_cutting_partitions
                                  : 0}{" "}
                              </p>
                            </Col>{" "} */}
                                      </Row>{" "}
                                    </CollapsePanel>
                                  </Collapse>
                                </Row>
                              </div>
                            </Panes>
                            {!job.jobcard[`solution_${1}`].data.exception &&
                              !(
                                parseFloat(currentSolution) > 2 &&
                                failedNewSol[jobIndex]
                              ) && (
                                <Panes
                                  tab={
                                    <span>
                                      Size Fulfilment
                                      {activeTab == "2" && (
                                        <Button
                                          key="1"
                                          style={{ border: "none" }}
                                          onClick={(e) =>
                                            setSizeExpanded(!sizeExpanded)
                                          }
                                        >
                                          <Iconmoon
                                            icon={
                                              sizeExpanded
                                                ? "contract_arrow"
                                                : "expand_arrow"
                                            }
                                            size={14}
                                            color="#EA4E2C"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  }
                                  key="2"
                                >
                                  <TableLayoutData>
                                    <div
                                      className="tableDataFormat  "
                                      style={{ marginTop: "25px" }}
                                    >
                                      <Table
                                        columns={sizeFulfillmentColumnsHead}
                                        dataSource={
                                          !job.jobcard[`solution_${1}`].data
                                            .exception && sizesTabData
                                        }
                                        onChange={(pagination) => {}}
                                        scroll={{ x: 1200 }}
                                        rowClassName={(record) =>
                                          record.priority && "true"
                                        }
                                      />
                                    </div>
                                  </TableLayoutData>
                                </Panes>
                              )}
                            {!job.jobcard[`solution_${1}`].data.exception &&
                              !(
                                parseFloat(currentSolution) > 2 &&
                                failedNewSol[jobIndex]
                              ) && (
                                <Panes
                                  tab={
                                    <span>
                                      Order Fulfillment
                                      {activeTab == "3" && (
                                        <Button
                                          key="1"
                                          style={{ border: "none" }}
                                          onClick={(e) =>
                                            setSizeExpanded(!sizeExpanded)
                                          }
                                        >
                                          <Iconmoon
                                            icon={
                                              sizeExpanded
                                                ? "contract_arrow"
                                                : "expand_arrow"
                                            }
                                            size={14}
                                            color="#EA4E2C"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  }
                                  key="3"
                                  // disabled={solutionSummary?.solution1.exception}
                                >
                                  <TableLayoutData>
                                    <div
                                      className="tableDataFormat"
                                      style={{ marginTop: "25px" }}
                                    >
                                      {isFetchingData ? (
                                        <TableShimmer
                                          header={orderFulfillmentColumnsHead}
                                          scroll={1600}
                                        />
                                      ) : (
                                        <Table
                                          columns={orderFulfillmentColumnsHead}
                                          dataSource={solutionTableData}
                                          onChange={onChange}
                                          scroll={{ x: 1800 }}
                                          rowClassName={(record) =>
                                            record.priority && "true"
                                          }
                                          pagination={{
                                            current: currentPage,
                                            pageSize: pageSize,
                                            total: solutionTableData?.length,
                                            onChange: onPaginationChange,
                                            showSizeChanger: true,
                                            showQuickJumper: true,
                                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                          }}
                                        />
                                      )}
                                    </div>
                                  </TableLayoutData>
                                </Panes>
                              )}
                            {/* <Panes
                              tab={
                                <span>
                                  Unfulfilled Orders
                                  {activeTab == "4" && (
                                    <Button
                                      key="1"
                                      style={{ border: "none" }}
                                      onClick={(e) =>
                                        setSizeExpanded(!sizeExpanded)
                                      }
                                    >
                                      <Iconmoon
                                        icon={
                                          sizeExpanded
                                            ? "contract_arrow"
                                            : "expand_arrow"
                                        }
                                        size={14}
                                        color="#EA4E2C"
                                      />
                                    </Button>
                                  )}
                                </span>
                              }
                              key="4"
                              // disabled={solutionSummary?.solution1.exception}
                            >
                              <TableLayoutData>
                                <div
                                  className="tableDataFormat"
                                  style={{ marginTop: "25px" }}
                                >
                                  {isFetchingData ? (
                                    <TableShimmer
                                      header={unfulfilledColumnsHead}
                                      scroll={1600}
                                    />
                                  ) : (
                                    <Table
                                      columns={unfulfilledColumnsHead}
                                      dataSource={
                                        job.jobcard[`solution_${1}`].data
                                          .exception ||
                                        (currentSolution > 2 &&
                                          failedNewSol[jobIndex]) ||
                                        (currentSolution == "1" &&
                                          job?.isFailedJobcard)
                                          ? failedJobOrders
                                          : solutionTableData?.filter(
                                              (order) =>
                                                parseFloat(
                                                  order?.unFulflilledWeight?.split(
                                                    " ",
                                                  )[0],
                                                ) > 0,
                                            )
                                      }
                                      onChange={(pagination) =>
                                        onChange(pagination, true)
                                      }
                                      scroll={{ x: 1800 }}
                                      rowClassName={(record) =>
                                        record.priority && "true"
                                      }
                                      pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        total: totalUnfulfilledOrders,
                                        onChange: onPaginationChange,
                                        showSizeChanger: true,
                                        showQuickJumper: true,
                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                      }}
                                    />
                                  )}
                                </div>
                              </TableLayoutData>
                            </Panes> */}
                            {!job.jobcard[`solution_${1}`].data.exception &&
                              !(
                                parseFloat(currentSolution) > 2 &&
                                failedNewSol[jobIndex]
                              ) && (
                                <Panes
                                  tab={
                                    <span>
                                      Intermediate Reels
                                      {activeTab == "5" && (
                                        <Button
                                          key="1"
                                          style={{ border: "none" }}
                                          onClick={(e) =>
                                            setSizeExpanded(!sizeExpanded)
                                          }
                                        >
                                          <Iconmoon
                                            icon={
                                              sizeExpanded
                                                ? "contract_arrow"
                                                : "expand_arrow"
                                            }
                                            size={14}
                                            color="#EA4E2C"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  }
                                  key="5"
                                  // disabled={solutionSummary?.solution1.exception}
                                >
                                  <TableLayoutData>
                                    <div
                                      className="tableDataFormat"
                                      style={{ marginTop: "25px" }}
                                    >
                                      <Table
                                        columns={intermediateColumnsHead}
                                        dataSource={intermediateData}
                                        onChange={(pagination) => {}}
                                        scroll={{ x: 1200 }}
                                        rowClassName={(record) =>
                                          record.priority && "true"
                                        }
                                      />
                                    </div>
                                  </TableLayoutData>
                                </Panes>
                              )}
                          </Tabs>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </SolutionContainer>
          </TabPane>
        )}
        {jobcardSolutionList.filter((solId) => solId == "2").length && (
          <TabPane key={"2"} tab={`Solution 2`}>
            <SolutionContainer>
              <PageTitleComp style={{ borderBottom: "0", padding: "0" }}>
                <PageHeader
                  ghost={false}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "50px",
                      }}
                    >
                      <span>
                        {job.state == "pending"
                          ? activeJC
                          : "Job Card " + activeJC}
                      </span>
                      {/* {job.state == "pending" ? (
                            (activeJC?.length > 20 ? (
                              <Tooltip placement="bottomLeft" title={activeJC}>
                                {activeJC?.slice(0,21)+"..."}
                              </Tooltip>
                              ) : (
                                activeJC
                            ))
                            ) : (
                            ("Job Card " + activeJC)
                            )
                          } */}
                    </div>
                  }
                  extra={
                    <div
                      className="extrasContainer"
                      style={{ display: "flex" }}
                    >
                      {!job.jobcard[`solution_${2}`].data.exception && [
                        job.jobcard[`solution_${2}`].status === "accept" ? (
                          <AlertContainer
                            color="green"
                            icon={alertGreen}
                            msg="The solution is sent for approval"
                          />
                        ) : job.jobcard[`solution_${2}`].status === "reject" ? (
                          job.jobcard[`solution_${2 == 1 ? "2" : "1"}`]
                            .status === "accept" ? (
                            <AlertContainer
                              color="green"
                              icon={alertGreen}
                              msg={`The${
                                isSolutionAccepted > 2 ? " new" : ""
                              } solution ${
                                isSolutionAccepted == 2 ||
                                isSolutionAccepted == 4
                                  ? "2"
                                  : "1"
                              } is already accepted`}
                            />
                          ) : (
                            <AlertContainer
                              color={isSolutionAccepted ? "green" : "red"}
                              icon={isSolutionAccepted ? alertGreen : alertRed}
                              msg={
                                isSolutionAccepted > 2
                                  ? `The new solution ${
                                      isSolutionAccepted - 2
                                    } is already accepted`
                                  : isSolutionAccepted
                                    ? `The solution ${isSolutionAccepted} is already accepted`
                                    : "The solution is discarded by the user"
                              }
                            />
                          )
                        ) : (
                          <RightSideSolution>
                            {!(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <div className="rightSideSolutionButtons">
                                <Button
                                  key="1"
                                  className="themeBtn noBg"
                                  onClick={() => discardModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isDiscardLoading}
                                >
                                  {!isDiscardLoading && (
                                    <Iconmoon
                                      icon="wrong"
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  )}
                                  Discard Solution
                                </Button>
                                <Button
                                  key="2"
                                  className="themeBtn"
                                  onClick={() => acceptModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isAcceptLoading}
                                >
                                  {!isAcceptLoading && (
                                    <Iconmoon
                                      icon="correct"
                                      size={14}
                                      color="#ffffff"
                                    />
                                  )}
                                  Accept Solution
                                </Button>
                              </div>
                            )}
                          </RightSideSolution>
                        ),
                      ]}
                    </div>
                  }
                  style={{ marginBottom: "10px", height: "50px" }}
                />
              </PageTitleComp>
              <div className="MatchResult">
                <Row span={24} className="pipeBlockCylinder">
                  {((!sizeExpanded && activeTab == "2") ||
                    (!sizeExpanded && activeTab == "3") ||
                    (!sizeExpanded && activeTab == "4") ||
                    (!sizeExpanded && activeTab == "5") ||
                    activeTab == "1") && (
                    <Col
                      span={15}
                      className="pipeBlock"
                      style={{ paddingRight: "20px" }}
                    >
                      {" "}
                      <RightSideSolution>
                        {!jobcardData?.jobcard[`solution_${2}`]?.data
                          ?.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) ? (
                          // jobCardDetailsList &&
                          <>
                            <div>
                              <div
                                className="radioSwitchStyle"
                                style={{
                                  zIndex: 10,
                                  display: "flex",
                                  flexDirection: "row-reverse",
                                  gap: "20px",
                                  transform: "translateY(-50px)",
                                }}
                              >
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          // justifyContent: "flex-end",
                                          display: "flex",
                                          // paddingRight: "",
                                          // transform: "translate(-225px,-15px)",
                                          // position: "absolute",
                                          // width: "200px",
                                        }}
                                      >
                                        <Radio.Group
                                          options={filterViewData}
                                          onChange={handleViewChange}
                                          value={
                                            isJobcardView && isSheetView
                                              ? "both"
                                              : isJobcardView
                                                ? "reel"
                                                : "sheet"
                                          }
                                          optionType="button"
                                          buttonStyle="2"
                                          className={
                                            isSheetView && isJobcardView
                                              ? "allActive"
                                              : isSheetView
                                                ? "sheetActive"
                                                : "jcActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                              columnGap: "10px",

                                        }}
                                        
                                      >
                                        <Radio.Group
                                              options={cylinderMode}
                                              onChange={
                                                handleCylinderViewChange
                                              }
                                              value={cylinderViewData}
                                              optionType="button"
                                              buttonStyle="solid"
                                              className={
                                                cylinderViewData ===
                                                "production"
                                                  ? "ListViewActive"
                                                  : "gridViewActive"
                                              }
                                            />
                                        <Radio.Group
                                          options={gridViewData}
                                          onChange={handleViewChangeGrid}
                                          value={isTabularView}
                                          optionType="button"
                                          buttonStyle="2"
                                          className={
                                            !isTabularView
                                              ? "gridViewActive"
                                              : "ListViewActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: isJobcardView ? "block" : "none",
                                padding: "0px",
                                margin: "0px",
                                transform: "translateY(-50px)",
                              }}
                            >
                              <JobCardCylinderContainerMultistage
                                jobId={job?.id}
                                solution={2}
                                multiView={true}
                                deckle_match_page={true}
                                // style={{width:'80%'}}
                                deckleSize={calculateDeckleSize(
                                  jobcardData,
                                  true,
                                )}
                                solId={2}
                                rewinderName={`${
                                  jobcardData?.jobcard?.group.machines?.find(
                                    (item) => item.machine_type !== "cutter",
                                  )?.rewinder_name
                                }`}
                                isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                currentCylinderData={currentCylinderData}
                              />
                            </div>
                            {isSheetView && (
                              <>
                                <SheetJobCardCylinderContainerMultistage
                                  jobId={job?.id}
                                  solution={2}
                                  multiView={false}
                                  acceptedSolution={
                                    jobcardData?.jobcard[`solution_${2}`]
                                  }
                                  jobCard={job.jobcard}
                                  // print_function={
                                  //   orderDetailsList ? printJobCardDetails : null
                                  // }
                                  unitData={unitData}
                                  isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                  currentSolution={currentSolution}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="deckleCoverImage">
                              <img
                                src={deckleCover}
                                alt="deckle match result"
                              />
                            </div>
                            {/* Exception message */}
                            <div className="colLayoutBlock deckleErrorLayout">
                              <p style={{ color: "#EA655B" }}>
                                {!(
                                  parseFloat(currentSolution) > 2 &&
                                  failedNewSol[jobIndex]
                                )
                                  ? jobcardData?.jobcard[`solution_${2}`]?.data
                                      ?.exception
                                  : "Job card could not be created for the input. Please check the input and try again"}
                              </p>
                            </div>
                          </>
                        )}
                      </RightSideSolution>
                    </Col>
                  )}
                  <Col
                    span={
                      ((sizeExpanded && activeTab == "2") ||
                        (sizeExpanded && activeTab == "3") ||
                        (sizeExpanded && activeTab == "4") ||
                        (sizeExpanded && activeTab == "5")) &&
                      activeTab != "1"
                        ? 24
                        : 9
                    }
                    className="colLayoutBlock"
                  >
                    <Tabs
                      defaultActiveKey={currentSummaryTab}
                      activeKey={currentSummaryTab}
                      className="topPostTab innerPostTab"
                      onChange={(key) => {
                        onPaginationChange(1, 10);
                        setCurrentSummaryTab(key);
                        setActiveTab(key);
                      }}
                    >
                      <Panes
                        tab={`Solution ${2} summary`}
                        key="1"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <div className="lossValue">
                          {!jobcardData?.jobcard[`solution_${2}`]?.data
                            ?.exception &&
                            !(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Trim
                                        Loss
                                      </h5>
                                      <span>
                                        {`${job?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] > 0 &&
                                          2 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] < 0 &&
                                          2 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {2 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {2 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Fulfillment
                                      </h5>
                                      <span>
                                        {`${jobcardData?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.weight_requirement_fulfilled_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        // jobcardData?.jobcard[`solution_${2}`]?.data?.summary
                                        //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] > 0 &&
                                          2 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] < 0 &&
                                          2 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {2 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {2 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                </Row>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Net
                                        Trim Loss:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                          3,
                                        )}{" "}
                                        %<p>Loss including edge trim</p>
                                      </h5>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Weight:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${2}`
                                        ].data.summary.job_card_weight?.toFixed(
                                          3,
                                        )}{" "}
                                        {capitalize(
                                          weightUnit[
                                            job.jobcard[`solution_${2}`].data
                                              .summary.units?.job_card_weight
                                          ]?.displayName,
                                        )}
                                        <p className="lesserSolution">
                                          Total weight of Job Card
                                        </p>
                                      </h5>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          <Row span={24}>
                            {/* <div className="sub-category"> */}

                            <Collapse
                              className="sub-category"
                              expandIconPosition="right"
                              defaultActiveKey={["1", "2", "3", "4"]}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CollapsePanel
                                key="1"
                                header="General Information"
                              >
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={11}>
                                    {" "}
                                    <span>Product Specifications</span>
                                    <p
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {job.jobcard?.group?.product.product_spec}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Priority Quantity</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.forced_weight_requirement
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.forced_weight_requirement.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.forced_weight_requirement
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .forced_weight_requirement
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                </Row>
                              </CollapsePanel>

                              <CollapsePanel key="2" header="Paper Machine">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Paper Machine</span>
                                    <p>{job.jobcard.group.machines[0].name}</p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Deckle Width</span>
                                    <p>{calculateDeckleSize(job)}</p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="3" header="Rewinding">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Rewinding Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.net_rewinding_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.net_rewinding_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.net_rewinding_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .net_rewinding_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.rewinding_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.rewinding_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.rewinding_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Rewinder</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "rewinder",
                                        )[0]?.rewinder_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary
                                        ?.rewinder_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.rewinder_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.rewinder_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .rewinder_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.unique_rewinding_partitions
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.unique_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.total_rewinding_partitions
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.total_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="4" header="Cutting">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Cutting Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.net_cutting_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.net_cutting_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.net_cutting_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .net_cutting_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.cutting_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.cutting_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.cutting_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .cutting_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Cutter</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "cutter",
                                        )[0]?.cutter_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary
                                        ?.cutting_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.cutting_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.cutting_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .cutting_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.unique_cutting_patterns
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.unique_cutting_patterns
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  {/* <Col span={11}>
                              <span>Total Number of Sets</span>
                              <p>
                                {job.jobcard[`solution_${2}`]?.data?.summary
                                  ?.total_cutting_partitions
                                  ? job.jobcard[`solution_${2}`].data
                                      .summary.total_cutting_partitions
                                  : 0}{" "}
                              </p>
                            </Col>{" "} */}
                                </Row>{" "}
                              </CollapsePanel>
                            </Collapse>
                          </Row>
                        </div>
                      </Panes>
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Size Fulfilment
                                {activeTab == "2" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="2"
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat  "
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={sizeFulfillmentColumnsHead}
                                  dataSource={
                                    !job.jobcard[`solution_${2}`].data
                                      .exception && sizesTabData
                                  }
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Order Fulfillment
                                {activeTab == "3" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="3"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                {isFetchingData ? (
                                  <TableShimmer
                                    header={orderFulfillmentColumnsHead}
                                    scroll={1600}
                                  />
                                ) : (
                                  <Table
                                    columns={orderFulfillmentColumnsHead}
                                    dataSource={solutionTableData}
                                    onChange={onChange}
                                    scroll={{ x: 1800 }}
                                    rowClassName={(record) =>
                                      record.priority && "true"
                                    }
                                    pagination={{
                                      current: currentPage,
                                      pageSize: pageSize,
                                      total: solutionTableData?.length,
                                      onChange: onPaginationChange,
                                      showSizeChanger: true,
                                      showQuickJumper: true,
                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    }}
                                  />
                                )}
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {/* <Panes
                        tab={
                          <span>
                            Unfulfilled Orders
                            {activeTab == "4" && (
                              <Button
                                key="1"
                                style={{ border: "none" }}
                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                              >
                                <Iconmoon
                                  icon={
                                    sizeExpanded
                                      ? "contract_arrow"
                                      : "expand_arrow"
                                  }
                                  size={14}
                                  color="#EA4E2C"
                                />
                              </Button>
                            )}
                          </span>
                        }
                        key="4"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <TableLayoutData>
                          <div
                            className="tableDataFormat"
                            style={{ marginTop: "25px" }}
                          >
                            {isFetchingData ? (
                              <TableShimmer
                                header={unfulfilledColumnsHead}
                                scroll={1600}
                              />
                            ) : (
                              <Table
                                columns={unfulfilledColumnsHead}
                                dataSource={
                                  job.jobcard[`solution_${2}`].data.exception ||
                                  (currentSolution > 2 &&
                                    failedNewSol[jobIndex]) ||
                                  (currentSolution == "1" &&
                                    job?.isFailedJobcard)
                                    ? failedJobOrders
                                    : solutionTableData?.filter(
                                        (order) =>
                                          parseFloat(
                                            order?.unFulflilledWeight?.split(
                                              " ",
                                            )[0],
                                          ) > 0,
                                      )
                                }
                                onChange={(pagination) =>
                                  onChange(pagination, true)
                                }
                                scroll={{ x: 1800 }}
                                rowClassName={(record) =>
                                  record.priority && "true"
                                }
                                pagination={{
                                  current: currentPage,
                                  pageSize: pageSize,
                                  total: totalUnfulfilledOrders,
                                  onChange: onPaginationChange,
                                  showSizeChanger: true,
                                  showQuickJumper: true,
                                  // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }}
                              />
                            )}
                          </div>
                        </TableLayoutData>
                      </Panes> */}
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Intermediate Reels
                                {activeTab == "5" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="5"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={intermediateColumnsHead}
                                  dataSource={intermediateData}
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                    </Tabs>
                  </Col>
                </Row>
              </div>
            </SolutionContainer>
          </TabPane>
        )}
        {jobcardSolutionList.filter((solId) => solId == "3").length && (
          <TabPane key={"3"} tab={`New Solution 1`}>
            <SolutionContainer>
              <PageTitleComp style={{ borderBottom: "0", padding: "0" }}>
                <PageHeader
                  ghost={false}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "50px",
                      }}
                    >
                      <span>
                        {job.state == "pending" ? "" : "Job Card "}
                        {/* {jobCardDetailsList[jobIndex]?.isFailedJobcard ? 
                       (jobCardDetailsList[jobIndex]?.isSuccessful ? activeJC : "") :  */}
                        {activeJC}
                      </span>
                      {/* {job.state == "pending" ? (
                            (activeJC?.length > 20 ? (
                              <Tooltip placement="bottomLeft" title={activeJC}>
                                {activeJC?.slice(0,21)+"..."}
                              </Tooltip>
                              ) : (
                                activeJC
                            ))
                            ) : (
                            ("Job Card " + activeJC)
                            )
                          } */}
                    </div>
                  }
                  extra={
                    <div
                      className="extrasContainer"
                      style={{ display: "flex" }}
                    >
                      {!job.jobcard[`solution_${1}`].data.exception && [
                        job.jobcard[`solution_${1}`].status === "accept" ? (
                          <AlertContainer
                            color="green"
                            icon={alertGreen}
                            msg="The solution is sent for approval"
                          />
                        ) : job.jobcard[`solution_${1}`].status === "reject" ? (
                          job.jobcard[`solution_${3 == 1 ? "2" : "1"}`]
                            .status === "accept" ? (
                            <AlertContainer
                              color="green"
                              icon={alertGreen}
                              msg={`The${
                                isSolutionAccepted > 2 ? " new" : ""
                              } solution ${
                                isSolutionAccepted == 2 ||
                                isSolutionAccepted == 4
                                  ? "2"
                                  : "1"
                              } is already accepted`}
                            />
                          ) : (
                            <AlertContainer
                              color={isSolutionAccepted ? "green" : "red"}
                              icon={isSolutionAccepted ? alertGreen : alertRed}
                              msg={
                                isSolutionAccepted > 2
                                  ? `The new solution ${
                                      isSolutionAccepted - 2
                                    } is already accepted`
                                  : isSolutionAccepted
                                    ? `The solution ${isSolutionAccepted} is already accepted`
                                    : "The solution is discarded by the user"
                              }
                            />
                          )
                        ) : (
                          <RightSideSolution>
                            {!(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <div className="rightSideSolutionButtons">
                                <Button
                                  key="1"
                                  className="themeBtn noBg"
                                  onClick={() => discardModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isDiscardLoading}
                                >
                                  {!isDiscardLoading && (
                                    <Iconmoon
                                      icon="wrong"
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  )}
                                  Discard Solution
                                </Button>
                                <Button
                                  key="2"
                                  className="themeBtn"
                                  onClick={() => acceptModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isAcceptLoading}
                                >
                                  {!isAcceptLoading && (
                                    <Iconmoon
                                      icon="correct"
                                      size={14}
                                      color="#ffffff"
                                    />
                                  )}
                                  Accept Solution
                                </Button>
                              </div>
                            )}
                          </RightSideSolution>
                        ),
                      ]}
                    </div>
                  }
                  style={{ marginBottom: "10px", height: "50px" }}
                />
              </PageTitleComp>
              <div className="MatchResult">
                <Row span={24} className="pipeBlockCylinder">
                  {((!sizeExpanded && activeTab == "2") ||
                    (!sizeExpanded && activeTab == "3") ||
                    (!sizeExpanded && activeTab == "4") ||
                    (!sizeExpanded && activeTab == "5") ||
                    activeTab == "1") && (
                    <Col
                      span={15}
                      className="pipeBlock"
                      style={{ paddingRight: "20px" }}
                    >
                      {" "}
                      <RightSideSolution>
                        {!jobcardData?.jobcard[`solution_${1}`]?.data
                          ?.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) ? (
                          // jobCardDetailsList &&
                          <>
                            <div>
                              <div
                                className="radioSwitchStyle"
                                style={{
                                  zIndex: 10,
                                  display: "flex",
                                  flexDirection: "row-reverse",
                                  gap: "20px",
                                  transform: "translateY(-50px)",
                                }}
                              >
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          // justifyContent: "flex-end",
                                          display: "flex",
                                          // paddingRight: "",
                                          // transform: "translate(-225px,-15px)",
                                          // position: "absolute",
                                          // width: "200px",
                                        }}
                                      >
                                        <Radio.Group
                                          options={filterViewData}
                                          onChange={handleViewChange}
                                          value={
                                            isJobcardView && isSheetView
                                              ? "both"
                                              : isJobcardView
                                                ? "reel"
                                                : "sheet"
                                          }
                                          optionType="button"
                                          buttonStyle="3"
                                          className={
                                            isSheetView && isJobcardView
                                              ? "allActive"
                                              : isSheetView
                                                ? "sheetActive"
                                                : "jcActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                              columnGap: "10px",

                                        }}
                                      >
                                        <Radio.Group
                                              options={cylinderMode}
                                              onChange={
                                                handleCylinderViewChange
                                              }
                                              value={cylinderViewData}
                                              optionType="button"
                                              buttonStyle="solid"
                                              className={
                                                cylinderViewData ===
                                                "production"
                                                  ? "ListViewActive"
                                                  : "gridViewActive"
                                              }
                                            />
                                        <Radio.Group
                                          options={gridViewData}
                                          onChange={handleViewChangeGrid}
                                          value={isTabularView}
                                          optionType="button"
                                          buttonStyle="3"
                                          className={
                                            !isTabularView
                                              ? "gridViewActive"
                                              : "ListViewActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: isJobcardView ? "block" : "none",
                                padding: "0px",
                                margin: "0px",
                                transform: "translateY(-50px)",
                              }}
                            >
                              <JobCardCylinderContainerMultistage
                                jobId={job?.id}
                                solution={1}
                                multiView={true}
                                deckle_match_page={true}
                                // style={{width:'80%'}}
                                deckleSize={calculateDeckleSize(
                                  jobcardData,
                                  true,
                                )}
                                solId={1}
                                rewinderName={`${
                                  jobcardData?.jobcard?.group.machines?.find(
                                    (item) => item.machine_type !== "cutter",
                                  )?.rewinder_name
                                }`}
                                isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                currentCylinderData={currentNewSolCylinderData}
                              />
                            </div>
                            {isSheetView && (
                              <>
                                <SheetJobCardCylinderContainerMultistage
                                  jobId={job?.id}
                                  solution={1}
                                  multiView={false}
                                  acceptedSolution={
                                    jobcardData?.jobcard[`solution_${1}`]
                                  }
                                  jobCard={job.jobcard}
                                  // print_function={
                                  //   orderDetailsList ? printJobCardDetails : null
                                  // }
                                  unitData={unitData}
                                  isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                  currentSolution={currentSolution}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="deckleCoverImage">
                              <img
                                src={deckleCover}
                                alt="deckle match result"
                              />
                            </div>
                            {/* Exception message */}
                            <div className="colLayoutBlock deckleErrorLayout">
                              <p style={{ color: "#EA655B" }}>
                                {!(
                                  parseFloat(currentSolution) > 2 &&
                                  failedNewSol[jobIndex]
                                )
                                  ? jobcardData?.jobcard[`solution_${1}`]?.data
                                      ?.exception
                                  : "Job card could not be created for the input. Please check the input and try again"}
                              </p>
                            </div>
                          </>
                        )}
                      </RightSideSolution>
                    </Col>
                  )}
                  <Col
                    span={
                      ((sizeExpanded && activeTab == "2") ||
                        (sizeExpanded && activeTab == "3") ||
                        (sizeExpanded && activeTab == "4") ||
                        (sizeExpanded && activeTab == "5")) &&
                      activeTab != "1"
                        ? 24
                        : 9
                    }
                    className="colLayoutBlock"
                  >
                    <Tabs
                      defaultActiveKey={currentSummaryTab}
                      activeKey={currentSummaryTab}
                      className="topPostTab innerPostTab"
                      onChange={(key) => {
                        onPaginationChange(1, 10);
                        setCurrentSummaryTab(key);
                        setActiveTab(key);
                      }}
                    >
                      <Panes
                        tab={`Solution ${1} summary`}
                        key="1"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <div className="lossValue">
                          {!jobcardData?.jobcard[`solution_${1}`]?.data
                            ?.exception &&
                            !(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Trim
                                        Loss
                                      </h5>
                                      <span>
                                        {`${job?.jobcard[
                                          `solution_${1}`
                                        ]?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] > 0 &&
                                          3 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] < 0 &&
                                          3 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {3 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {3 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Fulfillment
                                      </h5>
                                      <span>
                                        {`${jobcardData?.jobcard[
                                          `solution_${1}`
                                        ]?.data?.summary?.weight_requirement_fulfilled_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        // jobcardData?.jobcard[`solution_${1}`]?.data?.summary
                                        //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] > 0 &&
                                          3 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] < 0 &&
                                          3 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {3 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {3 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                </Row>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Net
                                        Trim Loss:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${1}`
                                        ]?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                          3,
                                        )}{" "}
                                        %<p>Loss including edge trim</p>
                                      </h5>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Weight:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${1}`
                                        ].data.summary.job_card_weight?.toFixed(
                                          3,
                                        )}{" "}
                                        {capitalize(
                                          weightUnit[
                                            job.jobcard[`solution_${1}`].data
                                              .summary.units?.job_card_weight
                                          ]?.displayName,
                                        )}
                                        <p className="lesserSolution">
                                          Total weight of Job Card
                                        </p>
                                      </h5>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          <Row span={24}>
                            {/* <div className="sub-category"> */}

                            <Collapse
                              className="sub-category"
                              expandIconPosition="right"
                              defaultActiveKey={["1", "2", "3", "4"]}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CollapsePanel
                                key="1"
                                header="General Information"
                              >
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={11}>
                                    {" "}
                                    <span>Product Specifications</span>
                                    <p
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {job.jobcard?.group?.product.product_spec}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Priority Quantity</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.forced_weight_requirement
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.forced_weight_requirement.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.forced_weight_requirement
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .forced_weight_requirement
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                </Row>
                              </CollapsePanel>

                              <CollapsePanel key="2" header="Paper Machine">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Paper Machine</span>
                                    <p>{job.jobcard.group.machines[0].name}</p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Deckle Width</span>
                                    <p>{calculateDeckleSize(job)}</p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="3" header="Rewinding">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Rewinding Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.net_rewinding_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.net_rewinding_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.net_rewinding_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .net_rewinding_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.rewinding_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.rewinding_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.rewinding_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Rewinder</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "rewinder",
                                        )[0]?.rewinder_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary
                                        ?.rewinder_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.rewinder_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.rewinder_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .rewinder_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.unique_rewinding_partitions
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.unique_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.total_rewinding_partitions
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.total_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="4" header="Cutting">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Cutting Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.net_cutting_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.net_cutting_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.net_cutting_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .net_cutting_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.cutting_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.cutting_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units?.cutting_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .cutting_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Cutter</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "cutter",
                                        )[0]?.cutter_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary
                                        ?.cutting_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${1}`
                                          ].data.summary.cutting_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.units
                                        ?.cutting_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${1}`].data
                                                .summary?.units
                                                .cutting_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${1}`]?.data
                                        ?.summary?.unique_cutting_patterns
                                        ? job.jobcard[`solution_${1}`].data
                                            .summary.unique_cutting_patterns
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  {/* <Col span={11}>
                              <span>Total Number of Sets</span>
                              <p>
                                {job.jobcard[`solution_${1}`]?.data?.summary
                                  ?.total_cutting_partitions
                                  ? job.jobcard[`solution_${1}`].data
                                      .summary.total_cutting_partitions
                                  : 0}{" "}
                              </p>
                            </Col>{" "} */}
                                </Row>{" "}
                              </CollapsePanel>
                            </Collapse>
                          </Row>
                        </div>
                      </Panes>
                      {!job.jobcard[`solution_${1}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Size Fulfilment
                                {activeTab == "2" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="2"
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat  "
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={sizeFulfillmentColumnsHead}
                                  dataSource={
                                    !job.jobcard[`solution_${1}`].data
                                      .exception && sizesTabData
                                  }
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {!job.jobcard[`solution_${1}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Order Fulfillment
                                {activeTab == "3" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="3"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                {isFetchingData ? (
                                  <TableShimmer
                                    header={orderFulfillmentColumnsHead}
                                    scroll={1600}
                                  />
                                ) : (
                                  <Table
                                    columns={orderFulfillmentColumnsHead}
                                    dataSource={solutionTableData}
                                    onChange={onChange}
                                    scroll={{ x: 1800 }}
                                    rowClassName={(record) =>
                                      record.priority && "true"
                                    }
                                    pagination={{
                                      current: currentPage,
                                      pageSize: pageSize,
                                      total: solutionTableData?.length,
                                      onChange: onPaginationChange,
                                      showSizeChanger: true,
                                      showQuickJumper: true,
                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    }}
                                  />
                                )}
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {/* <Panes
                        tab={
                          <span>
                            Unfulfilled Orders
                            {activeTab == "4" && (
                              <Button
                                key="1"
                                style={{ border: "none" }}
                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                              >
                                <Iconmoon
                                  icon={
                                    sizeExpanded
                                      ? "contract_arrow"
                                      : "expand_arrow"
                                  }
                                  size={14}
                                  color="#EA4E2C"
                                />
                              </Button>
                            )}
                          </span>
                        }
                        key="4"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <TableLayoutData>
                          <div
                            className="tableDataFormat"
                            style={{ marginTop: "25px" }}
                          >
                            {isFetchingData ? (
                              <TableShimmer
                                header={unfulfilledColumnsHead}
                                scroll={1600}
                              />
                            ) : (
                              <Table
                                columns={unfulfilledColumnsHead}
                                dataSource={
                                  job.jobcard[`solution_${1}`].data.exception ||
                                  (currentSolution > 2 &&
                                    failedNewSol[jobIndex]) ||
                                  (currentSolution == "1" &&
                                    job?.isFailedJobcard)
                                    ? failedJobOrders
                                    : solutionTableData?.filter(
                                        (order) =>
                                          parseFloat(
                                            order?.unFulflilledWeight?.split(
                                              " ",
                                            )[0],
                                          ) > 0,
                                      )
                                }
                                onChange={(pagination) =>
                                  onChange(pagination, true)
                                }
                                scroll={{ x: 1800 }}
                                rowClassName={(record) =>
                                  record.priority && "true"
                                }
                                pagination={{
                                  current: currentPage,
                                  pageSize: pageSize,
                                  total: totalUnfulfilledOrders,
                                  onChange: onPaginationChange,
                                  showSizeChanger: true,
                                  showQuickJumper: true,
                                  // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }}
                              />
                            )}
                          </div>
                        </TableLayoutData>
                      </Panes> */}
                      {!job.jobcard[`solution_${1}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Intermediate Reels
                                {activeTab == "5" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="5"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={intermediateColumnsHead}
                                  dataSource={intermediateData}
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                    </Tabs>
                  </Col>
                </Row>
              </div>
            </SolutionContainer>
          </TabPane>
        )}
        {jobcardSolutionList.filter((solId) => solId == "4").length && (
          <TabPane key={"4"} tab={`New Solution 2`}>
            <SolutionContainer>
              <PageTitleComp style={{ borderBottom: "0", padding: "0" }}>
                <PageHeader
                  ghost={false}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "50px",
                      }}
                    >
                      <span>
                        {job.state == "pending" ? "" : "Job Card "}
                        {/* {jobCardDetailsList[jobIndex]?.isFailedJobcard ? 
                       (jobCardDetailsList[jobIndex]?.isSuccessful ? activeJC : "") :  */}
                        {activeJC}
                      </span>
                      {/* {job.state == "pending" ? (
                            (activeJC?.length > 20 ? (
                              <Tooltip placement="bottomLeft" title={activeJC}>
                                {activeJC?.slice(0,21)+"..."}
                              </Tooltip>
                              ) : (
                                activeJC
                            ))
                            ) : (
                            ("Job Card " + activeJC)
                            )
                          } */}
                    </div>
                  }
                  extra={
                    <div
                      className="extrasContainer"
                      style={{ display: "flex" }}
                    >
                      {!job.jobcard[`solution_${2}`].data.exception && [
                        job.jobcard[`solution_${2}`].status === "accept" ? (
                          <AlertContainer
                            color="green"
                            icon={alertGreen}
                            msg="The solution is sent for approval"
                          />
                        ) : job.jobcard[`solution_${2}`].status === "reject" ? (
                          job.jobcard[`solution_${4 == 1 ? "2" : "1"}`]
                            .status === "accept" ? (
                            <AlertContainer
                              color="green"
                              icon={alertGreen}
                              msg={`The${
                                isSolutionAccepted > 2 ? " new" : ""
                              } solution ${
                                isSolutionAccepted == 2 ||
                                isSolutionAccepted == 4
                                  ? "2"
                                  : "1"
                              } is already accepted`}
                            />
                          ) : (
                            <AlertContainer
                              color={isSolutionAccepted ? "green" : "red"}
                              icon={isSolutionAccepted ? alertGreen : alertRed}
                              msg={
                                isSolutionAccepted > 2
                                  ? `The new solution ${
                                      isSolutionAccepted - 2
                                    } is already accepted`
                                  : isSolutionAccepted
                                    ? `The solution ${isSolutionAccepted} is already accepted`
                                    : "The solution is discarded by the user"
                              }
                            />
                          )
                        ) : (
                          <RightSideSolution>
                            {!(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <div className="rightSideSolutionButtons">
                                <Button
                                  key="1"
                                  className="themeBtn noBg"
                                  onClick={() => discardModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isDiscardLoading}
                                >
                                  {!isDiscardLoading && (
                                    <Iconmoon
                                      icon="wrong"
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  )}
                                  Discard Solution
                                </Button>
                                <Button
                                  key="2"
                                  className="themeBtn"
                                  onClick={() => acceptModalShow("solution1")}
                                  disabled={!userDetails.roles.job_cards.edit}
                                  loading={isAcceptLoading}
                                >
                                  {!isAcceptLoading && (
                                    <Iconmoon
                                      icon="correct"
                                      size={14}
                                      color="#ffffff"
                                    />
                                  )}
                                  Accept Solution
                                </Button>
                              </div>
                            )}
                          </RightSideSolution>
                        ),
                      ]}
                    </div>
                  }
                  style={{ marginBottom: "10px", height: "50px" }}
                />
              </PageTitleComp>
              <div className="MatchResult">
                <Row span={24} className="pipeBlockCylinder">
                  {((!sizeExpanded && activeTab == "2") ||
                    (!sizeExpanded && activeTab == "3") ||
                    (!sizeExpanded && activeTab == "4") ||
                    (!sizeExpanded && activeTab == "5") ||
                    activeTab == "1") && (
                    <Col
                      span={15}
                      className="pipeBlock"
                      style={{ paddingRight: "20px" }}
                    >
                      {" "}
                      <RightSideSolution>
                        {!jobcardData?.jobcard[`solution_${2}`]?.data
                          ?.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) ? (
                          // jobCardDetailsList &&
                          <>
                            <div>
                              <div
                                className="radioSwitchStyle"
                                style={{
                                  zIndex: 10,
                                  display: "flex",
                                  flexDirection: "row-reverse",
                                  gap: "20px",
                                  transform: "translateY(-50px)",
                                }}
                              >
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          // justifyContent: "flex-end",
                                          display: "flex",
                                          // paddingRight: "",
                                          // transform: "translate(-225px,-15px)",
                                          // position: "absolute",
                                          // width: "200px",
                                        }}
                                      >
                                        <Radio.Group
                                          options={filterViewData}
                                          onChange={handleViewChange}
                                          value={
                                            isJobcardView && isSheetView
                                              ? "both"
                                              : isJobcardView
                                                ? "reel"
                                                : "sheet"
                                          }
                                          optionType="button"
                                          buttonStyle="4"
                                          className={
                                            isSheetView && isJobcardView
                                              ? "allActive"
                                              : isSheetView
                                                ? "sheetActive"
                                                : "jcActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle1>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                          columnGap: "10px",
                                        }}
                                      >
                                        <Radio.Group
                                              options={cylinderMode}
                                              onChange={
                                                handleCylinderViewChange
                                              }
                                              value={cylinderViewData}
                                              optionType="button"
                                              buttonStyle="solid"
                                              className={
                                                cylinderViewData ===
                                                "production"
                                                  ? "ListViewActive"
                                                  : "gridViewActive"
                                              }
                                            />
                                        <Radio.Group
                                          options={gridViewData}
                                          onChange={handleViewChangeGrid}
                                          value={isTabularView}
                                          optionType="button"
                                          buttonStyle="4"
                                          className={
                                            !isTabularView
                                              ? "gridViewActive"
                                              : "ListViewActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle1>
                                  </HaberForm>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: isJobcardView ? "block" : "none",
                                padding: "0px",
                                margin: "0px",
                                transform: "translateY(-50px)",
                              }}
                            >
                              <JobCardCylinderContainerMultistage
                                jobId={job?.id}
                                solution={2}
                                multiView={true}
                                deckle_match_page={true}
                                // style={{width:'80%'}}
                                deckleSize={calculateDeckleSize(
                                  jobcardData,
                                  true,
                                )}
                                solId={2}
                                rewinderName={`${
                                  jobcardData?.jobcard?.group.machines?.find(
                                    (item) => item.machine_type !== "cutter",
                                  )?.rewinder_name
                                }`}
                                isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                currentCylinderData={currentNewSolCylinderData}
                              />
                            </div>
                            {isSheetView && (
                              <>
                                <SheetJobCardCylinderContainerMultistage
                                  jobId={job?.id}
                                  solution={2}
                                  multiView={false}
                                  acceptedSolution={
                                    jobcardData?.jobcard[`solution_${2}`]
                                  }
                                  jobCard={job.jobcard}
                                  // print_function={
                                  //   orderDetailsList ? printJobCardDetails : null
                                  // }
                                  unitData={unitData}
                                  isTabularView={isTabularView}
                              cylinderViewData={cylinderViewData}

                                  currentSolution={currentSolution}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="deckleCoverImage">
                              <img
                                src={deckleCover}
                                alt="deckle match result"
                              />
                            </div>
                            {/* Exception message */}
                            <div className="colLayoutBlock deckleErrorLayout">
                              <p style={{ color: "#EA655B" }}>
                                {!(
                                  parseFloat(currentSolution) > 2 &&
                                  failedNewSol[jobIndex]
                                )
                                  ? jobcardData?.jobcard[`solution_${2}`]?.data
                                      ?.exception
                                  : "Job card could not be created for the input. Please check the input and try again"}
                              </p>
                            </div>
                          </>
                        )}
                      </RightSideSolution>
                    </Col>
                  )}
                  <Col
                    span={
                      ((sizeExpanded && activeTab == "2") ||
                        (sizeExpanded && activeTab == "3") ||
                        (sizeExpanded && activeTab == "4") ||
                        (sizeExpanded && activeTab == "5")) &&
                      activeTab != "1"
                        ? 24
                        : 9
                    }
                    className="colLayoutBlock"
                  >
                    <Tabs
                      defaultActiveKey={currentSummaryTab}
                      activeKey={currentSummaryTab}
                      className="topPostTab innerPostTab"
                      onChange={(key) => {
                        onPaginationChange(1, 10);
                        setCurrentSummaryTab(key);
                        setActiveTab(key);
                      }}
                    >
                      <Panes
                        tab={`Solution ${2} summary`}
                        key="1"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <div className="lossValue">
                          {!jobcardData?.jobcard[`solution_${2}`]?.data
                            ?.exception &&
                            !(
                              parseFloat(currentSolution) > 2 &&
                              failedNewSol[jobIndex]
                            ) && (
                              <>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Trim
                                        Loss
                                      </h5>
                                      <span>
                                        {`${job?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] > 0 &&
                                          4 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchTrimLossKey
                                        ] < 0 &&
                                          4 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {4 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchTrimLossKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchTrimLossKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {4 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Fulfillment
                                      </h5>
                                      <span>
                                        {`${jobcardData?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.weight_requirement_fulfilled_percentage?.toFixed(
                                          3,
                                        )} %`}
                                      </span>
                                      {
                                        // jobcardData?.jobcard[`solution_${2}`]?.data?.summary
                                        //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] > 0 &&
                                          4 % 2 == 1) ||
                                        (jobcardData?.jobcard?.comparison?.[
                                          matchFulfilmentKey
                                        ] < 0 &&
                                          4 % 2 == 0) ? (
                                          <span className="lesserSolution">
                                            <img
                                              src={greaterRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts greater than{" "}
                                            {4 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        ) : (
                                          <span className="lesserSolution">
                                            <img
                                              src={lowerRange}
                                              style={{
                                                marginRight: "10px",
                                              }}
                                              alt=""
                                            />
                                            {jobcardData?.jobcard?.comparison?.[
                                              matchFulfilmentKey
                                            ]
                                              ? Math.abs(
                                                  jobcardData?.jobcard
                                                    ?.comparison?.[
                                                    matchFulfilmentKey
                                                  ],
                                                )?.toFixed(3)
                                              : 0}{" "}
                                            % pts lesser than{" "}
                                            {4 % 2 == 0 ? "1" : "2"}
                                          </span>
                                        )
                                        // ) : (
                                        //   <></>
                                        // )
                                      }
                                    </div>
                                  </Col>
                                </Row>
                                <Row span={24}>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimCut"></span> Net
                                        Trim Loss:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${2}`
                                        ]?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                          3,
                                        )}{" "}
                                        %<p>Loss including edge trim</p>
                                      </h5>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="summaryValue">
                                      <h5>
                                        <span className="trimBox"></span>{" "}
                                        Weight:{" "}
                                        {jobcardData?.jobcard[
                                          `solution_${2}`
                                        ].data.summary.job_card_weight?.toFixed(
                                          3,
                                        )}{" "}
                                        {capitalize(
                                          weightUnit[
                                            job.jobcard[`solution_${2}`].data
                                              .summary.units?.job_card_weight
                                          ]?.displayName,
                                        )}
                                        <p className="lesserSolution">
                                          Total weight of Job Card
                                        </p>
                                      </h5>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          <Row span={24}>
                            {/* <div className="sub-category"> */}

                            <Collapse
                              className="sub-category"
                              expandIconPosition="right"
                              defaultActiveKey={["1", "2", "3", "4"]}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CollapsePanel
                                key="1"
                                header="General Information"
                              >
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={11}>
                                    {" "}
                                    <span>Product Specifications</span>
                                    <p
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {job.jobcard?.group?.product.product_spec}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Priority Quantity</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.forced_weight_requirement
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.forced_weight_requirement.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.forced_weight_requirement
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .forced_weight_requirement
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                </Row>
                              </CollapsePanel>

                              <CollapsePanel key="2" header="Paper Machine">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Paper Machine</span>
                                    <p>{job.jobcard.group.machines[0].name}</p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Deckle Width</span>
                                    <p>{calculateDeckleSize(job)}</p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="3" header="Rewinding">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Rewinding Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.net_rewinding_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.net_rewinding_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.net_rewinding_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .net_rewinding_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.rewinding_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.rewinding_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.rewinding_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Rewinder</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "rewinder",
                                        )[0]?.rewinder_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary
                                        ?.rewinder_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.rewinder_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.rewinder_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .rewinder_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.unique_rewinding_partitions
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.unique_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.total_rewinding_partitions
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.total_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="4" header="Cutting">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Cutting Qty</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.net_cutting_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.net_cutting_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.net_cutting_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .net_cutting_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.cutting_net_trim_loss
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.cutting_net_trim_loss.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units?.cutting_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .cutting_net_trim_loss
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Cutter</span>{" "}
                                    <p>
                                      {
                                        job.jobcard?.group.machines?.filter(
                                          (item) =>
                                            item.machine_type === "cutter",
                                        )[0]?.cutter_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary
                                        ?.cutting_processed_order_quantity
                                        ? job.jobcard[
                                            `solution_${2}`
                                          ].data.summary.cutting_processed_order_quantity.toFixed(
                                            3,
                                          )
                                        : 0}{" "}
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.units
                                        ?.cutting_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              job.jobcard[`solution_${2}`].data
                                                .summary?.units
                                                .cutting_processed_order_quantity
                                            ]?.displayName,
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {job.jobcard[`solution_${2}`]?.data
                                        ?.summary?.unique_cutting_patterns
                                        ? job.jobcard[`solution_${2}`].data
                                            .summary.unique_cutting_patterns
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  {/* <Col span={11}>
                              <span>Total Number of Sets</span>
                              <p>
                                {job.jobcard[`solution_${2}`]?.data?.summary
                                  ?.total_cutting_partitions
                                  ? job.jobcard[`solution_${2}`].data
                                      .summary.total_cutting_partitions
                                  : 0}{" "}
                              </p>
                            </Col>{" "} */}
                                </Row>{" "}
                              </CollapsePanel>
                            </Collapse>
                          </Row>
                        </div>
                      </Panes>
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Size Fulfilment
                                {activeTab == "2" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="2"
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat  "
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={sizeFulfillmentColumnsHead}
                                  dataSource={
                                    !job.jobcard[`solution_${2}`].data
                                      .exception && sizesTabData
                                  }
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Order Fulfillment
                                {activeTab == "3" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="3"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                {isFetchingData ? (
                                  <TableShimmer
                                    header={orderFulfillmentColumnsHead}
                                    scroll={1600}
                                  />
                                ) : (
                                  <Table
                                    columns={orderFulfillmentColumnsHead}
                                    dataSource={solutionTableData}
                                    onChange={onChange}
                                    scroll={{ x: 1800 }}
                                    rowClassName={(record) =>
                                      record.priority && "true"
                                    }
                                    pagination={{
                                      current: currentPage,
                                      pageSize: pageSize,
                                      total: solutionTableData?.length,
                                      onChange: onPaginationChange,
                                      showSizeChanger: true,
                                      showQuickJumper: true,
                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    }}
                                  />
                                )}
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                      {/* <Panes
                        tab={
                          <span>
                            Unfulfilled Orders
                            {activeTab == "4" && (
                              <Button
                                key="1"
                                style={{ border: "none" }}
                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                              >
                                <Iconmoon
                                  icon={
                                    sizeExpanded
                                      ? "contract_arrow"
                                      : "expand_arrow"
                                  }
                                  size={14}
                                  color="#EA4E2C"
                                />
                              </Button>
                            )}
                          </span>
                        }
                        key="4"
                        // disabled={solutionSummary?.solution1.exception}
                      >
                        <TableLayoutData>
                          <div
                            className="tableDataFormat"
                            style={{ marginTop: "25px" }}
                          >
                            {isFetchingData ? (
                              <TableShimmer
                                header={unfulfilledColumnsHead}
                                scroll={1600}
                              />
                            ) : (
                              <Table
                                columns={unfulfilledColumnsHead}
                                dataSource={
                                  job.jobcard[`solution_${2}`].data.exception ||
                                  (currentSolution > 2 &&
                                    failedNewSol[jobIndex]) ||
                                  (currentSolution == "1" &&
                                    job?.isFailedJobcard)
                                    ? failedJobOrders
                                    : solutionTableData?.filter(
                                        (order) =>
                                          parseFloat(
                                            order?.unFulflilledWeight?.split(
                                              " ",
                                            )[0],
                                          ) > 0,
                                      )
                                }
                                onChange={(pagination) =>
                                  onChange(pagination, true)
                                }
                                scroll={{ x: 1800 }}
                                rowClassName={(record) =>
                                  record.priority && "true"
                                }
                                pagination={{
                                  current: currentPage,
                                  pageSize: pageSize,
                                  total: totalUnfulfilledOrders,
                                  onChange: onPaginationChange,
                                  showSizeChanger: true,
                                  showQuickJumper: true,
                                  // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }}
                              />
                            )}
                          </div>
                        </TableLayoutData>
                      </Panes> */}
                      {!job.jobcard[`solution_${2}`].data.exception &&
                        !(
                          parseFloat(currentSolution) > 2 &&
                          failedNewSol[jobIndex]
                        ) && (
                          <Panes
                            tab={
                              <span>
                                Intermediate Reels
                                {activeTab == "5" && (
                                  <Button
                                    key="1"
                                    style={{ border: "none" }}
                                    onClick={(e) =>
                                      setSizeExpanded(!sizeExpanded)
                                    }
                                  >
                                    <Iconmoon
                                      icon={
                                        sizeExpanded
                                          ? "contract_arrow"
                                          : "expand_arrow"
                                      }
                                      size={14}
                                      color="#EA4E2C"
                                    />
                                  </Button>
                                )}
                              </span>
                            }
                            key="5"
                            // disabled={solutionSummary?.solution1.exception}
                          >
                            <TableLayoutData>
                              <div
                                className="tableDataFormat"
                                style={{ marginTop: "25px" }}
                              >
                                <Table
                                  columns={intermediateColumnsHead}
                                  dataSource={intermediateData}
                                  onChange={(pagination) => {}}
                                  scroll={{ x: 1200 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                />
                              </div>
                            </TableLayoutData>
                          </Panes>
                        )}
                    </Tabs>
                  </Col>
                </Row>
              </div>
            </SolutionContainer>
          </TabPane>
        )}
        {/* ))} */}
      </Tabs>
    );
  };

  /** Removes `~` from API job card code strings for display. */
  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  }

  /** Accepts the chosen solution: calls API and updates job card + solution statuses in state. */
  const acceptModalConfirm = () => {
    setIsAcceptModal(false);
    setIsAcceptLoading(true);
    let jobCardId =
      currentSolution == 1 || currentSolution == 2
        ? jobCardDetailsList[jobIndex].id
        : jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0].id;

        let groupId =
      currentSolution == 1 || currentSolution == 2
        ? jobCardDetailsList[jobIndex].jobcard.group.group_id
        : jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0].jobcard
            .group.group_id;
    console.log(groupId);

    setAcceptedJCGrpCode([...acceptedJCGrpCode, groupId]);
    let solutionState =
      currentSolution == 1 || currentSolution == 3
        ? "solution_1"
        : "solution_2";
    let rejectedSolution =
      currentSolution == 1 || currentSolution == 3
        ? "solution_2"
        : "solution_1";
    setIsSolutionAccepted(currentSolution);
    putSolutionStatusMultistage(jobCardId, solutionState, "accept")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          setRenderKey(true);
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            const row = next[jobIndex];
            if (!row) return prev;
            const jcCode = getJCCode(response?.data?.jobcard_code);

            if (currentSolution == 1 || currentSolution == 2) {
              const updatedRow = {
                ...row,
                jc_code: jcCode,
                state: "pending",
                jobcard: {
                  ...row.jobcard,
                  [solutionState]: {
                    ...row.jobcard?.[solutionState],
                    status: "accept",
                  },
                  [rejectedSolution]: {
                    ...row.jobcard?.[rejectedSolution],
                    status: "reject",
                  },
                },
              };

              const ncd = row?.newlyCreatedJobCardsDetails || [];
              if (ncd.length) {
                const first = ncd[0];
                const updatedFirst = {
                  ...first,
                  jobcard: {
                    ...first.jobcard,
                    [solutionState]: {
                      ...first.jobcard?.[solutionState],
                      status: "reject",
                    },
                    [rejectedSolution]: {
                      ...first.jobcard?.[rejectedSolution],
                      status: "reject",
                    },
                  },
                };
                updatedRow.newlyCreatedJobCardsDetails = [
                  updatedFirst,
                  ...ncd.slice(1),
                ];
              }

              next[jobIndex] = updatedRow;
              return next;
            }

            const ncd = row?.newlyCreatedJobCardsDetails || [];
            if (!ncd.length) return prev;
            const first = ncd[0];
            const updatedFirst = {
              ...first,
              state: "pending",
              jobcard: {
                ...first.jobcard,
                [solutionState]: {
                  ...first.jobcard?.[solutionState],
                  status: "accept",
                },
                [rejectedSolution]: {
                  ...first.jobcard?.[rejectedSolution],
                  status: "reject",
                },
              },
            };

            next[jobIndex] = {
              ...row,
              jc_code: jcCode,
              jobcard: {
                ...row.jobcard,
                [solutionState]: {
                  ...row.jobcard?.[solutionState],
                  status: "reject",
                },
                [rejectedSolution]: {
                  ...row.jobcard?.[rejectedSolution],
                  status: "reject",
                },
              },
              newlyCreatedJobCardsDetails: [updatedFirst, ...ncd.slice(1)],
            };
            return next;
          });
          setAcceptSolCounter(true);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsAcceptLoading(false);
      });
  };
  /** Ant Design Table wrapper: syncs pagination state when user changes page or page size. */
  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }

  /** Updates local pagination state (used by order/size tables). */
  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    // isUnfulfilled && setIsUnfulfilledTab(true);
  };
  /** Refreshes order/solution data for the currently active job card (or failed job) after tab/solution changes. */
  const jobcardDataFetchFunction = () => {
    const activeJobIndex = jobCardDetailsList?.findIndex(
      (job) => job.id == activeJobcardRef.current
    );
    setJobIndex(activeJobIndex);
    const activeJobIndexFailed = failedJobs?.findIndex(
      (job) => job.id == activeJobcardRef.current
    );
    const detailsList = jobCardDetailsList;
    if (
      jobCardDetailsList &&
      activeJobIndex !== undefined &&
      activeJobIndex != -1 &&
      jobCardDetailsList[activeJobIndex]
    ) {
      const jobcardData =
        parseFloat(currentSolution) > 2 &&
        detailsList[activeJobIndex].newlyCreatedJobCardsDetails
          ? detailsList[activeJobIndex].newlyCreatedJobCardsDetails[0]?.jobcard
          : detailsList[activeJobIndex]?.jobcard;
      fetchOrdersData(
        jobcardData,
        parseFloat(currentSolution) > 2 && failedNewSol[jobIndex]
      );
    } else {
      fetchOrdersData(failedJobs[activeJobIndexFailed], true);
    }
  };
  /**
   * Fetches full job card details by id list; merges into the list or attaches `newlyCreatedJobCardsDetails` when creating a new solution.
   */
  const fetchJobcardDetails = (jobcardIds, parentJobCardId = 0, uuid = "") => {
    let newsolcnt = false;
    getJobCardsDetailsMultistage({ jobcards: jobcardIds })
      .then((response) => {
        if (!createNewSolutionClicked) {
          const tempJobcardDetailsList = [...jobCardDetailsList];

          response?.forEach((job) => {
            if (
              !tempJobcardDetailsList.some(
                (existingJob) => existingJob.id === job.id
              )
            ) {
              tempJobcardDetailsList.push(job);
            }
          });
           setCompareSolSummaryData({
            solution1: tempJobcardDetailsList,
            solution2: tempJobcardDetailsList
          });
          setJobCardDetailsList(tempJobcardDetailsList);
          setSyncFailedGroups(false);
        } else {
          newsolcnt = true;
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            const filteredJobCardIndex = next.findIndex((jobCardDetails) => {
              return jobCardDetails.uuid == uuid;
            });
            if (filteredJobCardIndex === -1) return prev;

            const row = next[filteredJobCardIndex];
            next[filteredJobCardIndex] = {
              ...row,
              newlyCreatedJobCardsDetails: response,
              ...(row?.isFailedJobcard ? { isSuccessful: true } : {}),
            };
            
            setCompareSolSummaryData({ solution1: next, solution2: next });
            setNewCompareSolSummaryData({ solution1: next, solution2: next });
            return next;
          });
          setCreateNewSolutionClicked(false);
          setIsTabularView(false);
        }
        const rewinderMachine = response[0]?.jobcard?.group?.machines?.find(
          (machine) => machine.machine_type === "rewinder"
        );
        const cutterMachine = response[0]?.jobcard?.group?.machines?.find(
          (machine) => machine.machine_type === "cutter"
        );
        let stockMachineValue = { ...formValuesForStock?.[jobIndex] };
        if (rewinderMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = rewinderMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: maxDeckleLength,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
          };
        }
        if (cutterMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            max_chop_size,
            min_chop_size,
            maximum_reel_dia,
            minimum_reel_dia,
            allowed_trim,
            units,
            cutters,
          } = cutterMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length_cutter: minDeckleLength,
            max_deckle_length_cutter: maxDeckleLength,
            maximum_cutters_cutter: original_cutters,
            effective_deckle_length_cutter: effective_deckle_length,
            left_edge_trim_cutter: left_edge_trim,
            right_edge_trim_cutter: right_edge_trim,
            min_chop_cutter: min_chop_size,
            max_chop_cutter: max_chop_size,
            min_dia_cutter: minimum_reel_dia,
            max_dia_cutter: maximum_reel_dia,
            units_cutter: units,
            max_trim_intermediate_cutter: allowed_trim,
            cutters_cutter: cutters,
          };
        }
        setFormValuesForStock({
          ...formValuesForStock,
          [jobIndex ? jobIndex : 0]: stockMachineValue,
        });
        // const orderIds = [];
        // response.forEach((item) => {
        //   item.jobcard?.group?.orders?.map((order) => {
        //     orderIds.push(order.order_id);
        //   });
        // });
        // setOrderIdList(orderIds);
      })
      .catch((error) => {
        newsolcnt = true;
        let detailsList = jobCardDetailsList;
        let filteredJobCardIndex = detailsList.findIndex(function (
          jobCardDetails
        ) {
          return jobCardDetails.uuid == uuid;
        });
       
        if (filteredJobCardIndex != -1)
          {
            let jobcardData = [
              {
                created_at: detailsList[filteredJobCardIndex].created_at,
                uuid: detailsList[filteredJobCardIndex].uuid,
                id: detailsList[filteredJobCardIndex].id,
                user_id: detailsList[filteredJobCardIndex].user_id,
                updated_at: detailsList[filteredJobCardIndex].updated_at,
                jobcard: {
                  group: detailsList[filteredJobCardIndex].jobcard.group,
                  solution_1: {
                    data: {
                      exception:
                        "Job card could not be created for the input.Please check the input and try again",
                    },
                  },
                  solution_2: {
                    data: {
                      exception:
                        "Job card could not be created for the input.Please check the input and try again",
                    },
                  },
                },
              },
            ];

          detailsList[filteredJobCardIndex] = {
            ...detailsList[filteredJobCardIndex],
            newlyCreatedJobCardsDetails: jobcardData,
          };
        if (!detailsList[filteredJobCardIndex]?.isFailedJobcard) {
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            next[filteredJobCardIndex] = detailsList[filteredJobCardIndex];
            return next;
          });
        }
        setCreateNewSolutionClicked(false);

      }});
    
  };

  useEffect(() => {
    if (
      location.state?.jobCards?.failed_groups?.length &&
      location.state?.jobCards?.jobcards?.length
    ) {
      setSyncFailedGroups(true);      
      if (JSON.stringify(jobcardIds) !== JSON.stringify(location.state?.jobCards.jobcards))
        setJobcardIds(location.state?.jobCards.jobcards);
      setFailedGroups(location.state?.jobCards.failed_groups);
    } else if (location.state?.jobCards.jobcards.length) {
      if (JSON.stringify(jobcardIds) !== JSON.stringify(location.state?.jobCards.jobcards))
        setJobcardIds(location.state?.jobCards.jobcards);
    } else {
      setFailedGroups(location.state?.jobCards.failed_groups);
    }
  }, []);
  useEffect(() => {
    setCurrentSummaryTab("1");
  }, [activeJobcard]);

  useEffect(() => {
    jobCardDetailsList[jobIndex]?.isFailedJobcard &&
    jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.length
      ? setCurrentSolution("3")
      : setCurrentSolution("compare");
    setCreateNewSolutionClicked(false);
  }, [jobIndex]);

  useEffect(() => {
    console.log('currentSolution',currentSolution);
    
  },[currentSolution])

  useEffect(() => {
    jobcardDataFetchFunction();
    if (syncFailedGroups) {
      if (!jobCardDetailsList.length) return;
      // setFailedGroups(location.state?.jobCards.failed_groups);
      // setSyncFailedGroups(false);
    }
  }, [
    activeJobcard,
    jobCardDetailsList,
    currentSolution,
    failedJobs,
  ]);

  useEffect(() => {
    if (currentSolution === "compare") return;
    jobcardDataFetchFunction();
  }, [currentSummaryTab]);

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(10);
    setCurrentSummaryTab("1");
  }, [currentSolution]);

  useEffect(() => {
    jobcardDataFetchFunction();
  }, [currentPage, pageSize]);
  /** Loads failed-group job card payloads when `failedGroups` is present on entry. */
  const handleFailedJCData = () => {
    getFailedGroups({ failed_groups: failedGroups })
      .then((response) => {
        let tempJC = jobCardDetailsList;
        let data = {
          orders: [],
          partitions: [],
          sizes: [],
          summary: {},
        };

        response.map((res) => {
          let jobcardData = {
            created_at: res.created_at,
            uuid: res.uuid,
            id: res.id,
            failedGroupId: res.id,
            //set isFailedJobcard true for all jobs who are failed initially
            isFailedJobcard: true,
            user_id: res.user_id,
            updated_at: res.updated_at,
            jobcard: {
              group: res.group,
              solution_1: { data },
              solution_2: { data },
              product: res?.group?.product,
            },
          };
          tempJC = [...tempJC.filter((jc) => jc.id !== res.id), jobcardData];
        });
        const uniqueJobCardDetailsList = Array.from(new Set(tempJC));

        setJobCardDetailsList(uniqueJobCardDetailsList);

        const rewinderMachine = response[0]?.group?.machines?.find(
          (machine) => machine.machine_type === "rewinder"
        );
        const cutterMachine = response[0]?.group?.machines?.find(
          (machine) => machine.machine_type === "cutter"
        );
        let stockMachineValue = { ...formValuesForStock?.[jobIndex] };
        if (rewinderMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = rewinderMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: maxDeckleLength,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
          };
        }
        if (cutterMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            max_chop_size,
            min_chop_size,
            maximum_reel_dia,
            minimum_reel_dia,
            allowed_trim,
            units,
            cutters,
          } = cutterMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length_cutter: minDeckleLength,
            max_deckle_length_cutter: maxDeckleLength,
            maximum_cutters_cutter: original_cutters,
            effective_deckle_length_cutter: effective_deckle_length,
            left_edge_trim_cutter: left_edge_trim,
            right_edge_trim_cutter: right_edge_trim,
            min_chop_cutter: min_chop_size,
            max_chop_cutter: max_chop_size,
            min_dia_cutter: minimum_reel_dia,
            max_dia_cutter: maximum_reel_dia,
            units_cutter: units,
            max_trim_intermediate_cutter: allowed_trim,
            cutters_cutter: cutters,
          };
        }

        setFormValuesForStock({ ...formValuesForStock, [jobIndex]: stockMachineValue });
      })
      .catch((error) => console.log("Error Message in failed jobcards", error));
  };
  useEffect(() => {
    if (failedGroups.length && !syncFailedGroups) handleFailedJCData();
  }, [failedGroups, syncFailedGroups]);

  useEffect(() => {
    if(isDataLoad)
      {
    setActiveJobcard(
      parseFloat(jobcardIds.length ? jobcardIds[0] : failedGroups[0])
    );
    activeJobcardRef.current = parseFloat(jobcardIds.length ? jobcardIds[0] : failedGroups[0]);
    setIsDataLoad(false);
  }
  }, [jobcardIds, failedGroups]);

  useEffect(() => {
    console.log('stopCancellApi', stopCancellApi.current, 'stopCancelled', stopCancelled);
     return () => {
       console.log('stopCancellApi', stopCancellApi.current, 'stopCancelled', stopCancelled);
       if (stopCancelled || stopCancellApi.current) return;
       cancelJobCard();
       stopCancellApi.current = false;
       setStopCancelled(false);
       handleResetAll('useffect deckle multistage');
     };
  }, []);

  useEffect(() => {
    setTimeout(process_failed_groups, 5000);
  }, []);

  useEffect(() => {
    (async () => {
      getUnitData()
        .then((response) => {
          setUnitData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, []);

  useEffect(() => {
    jobcardIds?.length && fetchJobcardDetails(jobcardIds);
    // setJobCardDetailsList(jobcardIds);
  }, [jobcardIds]);

  useEffect(() => {
    if(jobcardIds?.length && jobCardDetailsList?.length){
      let jcData = [];
      let jcObj = {};
      jobCardDetailsList.map((item, index) => {
        jcObj = {};
        jcObj["id"] = item?.id;
        if(item?.isFailedJobcard){
          if(item?.newlyCreatedJobCardsDetails?.length && item?.isSuccessful && item?.newlyCreatedJobCardsDetails[0]?.state == "pending" ){
            jcObj["jc_code"] = item?.jc_code;
          } else{
            jcObj["jc_code"] = (index+1);
          }
        } else{
          if(item?.state == "pending"){
            jcObj["jc_code"] = item?.jc_code;
          } else{
            jcObj["jc_code"] = (index+1);
          }
        }
        jcData.push(jcObj);
      });
      setJobcardIdsWithCode(jcData);
      if(currentActiveJC.current){
        let currentJCCode = jcData.filter((ele) => ele.id == currentActiveJC.current)
        currentActiveJC.current = currentJCCode[0]?.id;
        setActiveJC(currentJCCode[0]?.jc_code);
      } else{
        let selectedData;
        if(jobcardIds.length){
          selectedData = jcData?.filter((item) => item.id == jobcardIds[0]);
        } else{
          selectedData = jcData?.filter((item) => item.id == failedGroups[0])
        }
        currentActiveJC.current = selectedData[0]?.id;
        setActiveJC(selectedData[0]?.jc_code);
      }
      // setActiveJC(jcData[0]?.jc_code);
      setRenderKey(false);
    }
  },[jobcardIds, jobCardDetailsList, renderKey]);

  return (
    totalGroups && (
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Deckle Match Results"
            extra={[
              <Button
                key="1"
                className="themeBtn noBg noMargin"
                onClick={routeChange}
              >
                Go Back
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        {location?.state?.type!='replan'&& (failedGroups.length + jobcardIds.length != totalGroups ? (
          <div className="failedProgress">
            <span className="failedJobMessage">
              {jobcardIds.length + failedGroups.length} out of {totalGroups} Job
              Cards are generated, &nbsp;
              {`${
                totalGroups - (jobcardIds?.length + failedGroups?.length)
              }`}{" "}
              job cards are still in process
            </span>
            <Progress
              percent={
                ((jobcardIds?.length + failedGroups?.length) / totalGroups) *
                100
              }
              showInfo={false}
            />
          </div>
        ) : (
          <div className="failedProgress">
            <span className="failedJobMessage">
              All {totalGroups} Job Cards are generated
            </span>
            <Progress percent={100} showInfo={false} />
          </div>
        ))}
        {/* if failed groups and jobcards are eaul to total passed groups ? */}

        {(jobCardDetailsList || failedGroups) && (
          <ResultWrap1>
            <DetailFields>
              <Tabs
                defaultActiveKey={
                  jobcardIds.length ? jobcardIds[0] : failedGroups[0]
                }
                tabPosition="left"
                className="leftPostTab"
                onChange={onLeftTabChange}
                style={{ backgroundColor: "#faf9f8" }}
              >
                {jobCardDetailsList?.length &&
                  jobCardDetailsList.map((job, index) => (
                    <TabPane
                      key={job.id}
                      style={{
                        backgroundColor: "#ffffff",
                        borderLeft: "1px solid #ebebeb",
                      }}
                      tab={
                        job?.isFailedJobcard && !job?.isSuccessful ? (
                          <div className="deckleMatchIcon disabled">
                            <img src={failedIco} alt="" />
                            {"JC " +(index+1) + "(failed)"} 
                          </div>
                        ) : (
                          <div className="deckleMatchIcon disabled">
                            <img
                              src={
                                job.jobcard.solution_1.status === "accept" ||
                                job.jobcard.solution_2.status === "accept" ||
                                (job.newlyCreatedJobCardsDetails &&
                                  job.newlyCreatedJobCardsDetails.length &&
                                  job.newlyCreatedJobCardsDetails[0].jobcard
                                    .solution_1.status === "accept") ||
                                (job.newlyCreatedJobCardsDetails &&
                                  job.newlyCreatedJobCardsDetails.length &&
                                  job.newlyCreatedJobCardsDetails[0].jobcard
                                    .solution_2.status === "accept")
                                  ? alerttrue
                                  : job.jobcard.solution_1.status ===
                                      "reject" &&
                                    job.jobcard.solution_2.status ===
                                      "reject" &&
                                    job.newlyCreatedJobCardsDetails &&
                                    job.newlyCreatedJobCardsDetails.length &&
                                    job.newlyCreatedJobCardsDetails[0].jobcard
                                      .solution_1.status === "reject" &&
                                    job.newlyCreatedJobCardsDetails &&
                                    job.newlyCreatedJobCardsDetails.length &&
                                    job.newlyCreatedJobCardsDetails[0].jobcard
                                      .solution_2.status === "reject"
                                  ? wrongIco
                                  : job.jobcard.solution_1.data.exception ||
                                    job.jobcard.solution_2.data.exception ||
                                    (job.newlyCreatedJobCardsDetails &&
                                      job.newlyCreatedJobCardsDetails.length &&
                                      job.newlyCreatedJobCardsDetails[0].jobcard
                                        .solution_1.data.exception) ||
                                    (job.newlyCreatedJobCardsDetails &&
                                      job.newlyCreatedJobCardsDetails.length &&
                                      job.newlyCreatedJobCardsDetails[0].jobcard
                                        .solution_2.data.exception)
                                  ? warningjob
                                  : vectorIco
                              }
                              alt=""
                            />
                            {/* Job Card {job?.isFailedJobcard && job?.isSuccessful ? job?.newlyCreatedJobCardsDetails[0].id : job.id}*/}
                            {job?.jc_code ? 
                            (job?.jc_code?.length > 20 ? (
                              <Tooltip placement="bottomLeft" title={job?.jc_code}>
                              {job?.jc_code?.slice(0,21)+"..."}
                              </Tooltip>) : (
                              job?.jc_code
                            )): 
                            ("JC " + (index+1))}

                          </div>
                        )
                      }
                    >
                      {createNewSolutionClicked ? (
                        !showAimation[jobIndex] ? (
                          <CreateNewSolutionMultistage
                            id={activeJobcard}
                            key={activeJobcard}
                            jobId={jobCardDetailsList[index].id}
                            onClickCreateSolution={(e) =>
                              onClickCreateSolution(
                                e,
                                jobCardDetailsList[index].id,
                                jobCardDetailsList[index].uuid,
                                index
                              )
                            }
                            formValuesForStock={formValuesForStock?.[jobIndex]}
                            // job.jobcard.group.grouping_params.core_id
                            jobCardDetails={job.jobcard}
                            backButtonClicked={() => {
                              setCreateNewSolutionClicked(false);
                              handleCutterReelDiaChange();
                              setCurrentSolution("compare");
                            }}
                            stockSizesArray={
                              stockSizesByJobCard[jobCardDetailsList[jobIndex].id] || []
                            }
                            setStockSizesArray={setStockSizesForActiveJobcard}
                            createNewSolutionFormValuesForSizes={
                              createNewSolutionFormValuesByJobCard[
                                jobCardDetailsList[jobIndex].id
                              ]
                            }
                            unselectedOrders={
                              jobCardDetailsList[index]
                                ?.newlyCreatedJobCardsDetails
                                ? jobCardDetailsList[index]
                                    ?.newlyCreatedJobCardsDetails[0]?.jobcard
                                    ?.group?.unselected_orders
                                : jobCardDetailsList[index]?.jobcard?.group
                                    ?.unselected_orders
                            }
                            ordersIdList={currentOrdersIdList}
                            updateOrdersIdList={setOrdersIdListForActiveJobcard}
                            optimizePartition={optimizePartition}
                            minimizeOverfulfillment={minimizeOverfulfillment}
                            onOptimizePartitionChange={
                              handleOptimizePartitionChange
                            }
                            onMinimizeOverfulfillmentChange={
                              handleMinimizeOverfulfillmentChange
                            }
                            machineData = {location.state.body}
                            solutionId = {currentSolution}
                            completeJCDetails  = {jobCardDetailsList[jobIndex]}
                          />
                        ) : (
                          <RightLayoutContainer>
                            <ContentMiddle>
                              <div className="imageAnimate">
                                <div className="imageCover">
                                  <LottieAnimation lotti={JobcardPrepare} />
                                  <p>
                                    Our algorithms are cooking a job card for
                                    you <br />
                                    please wait, it will take less than a minute
                                  </p>
                                </div>
                              </div>
                            </ContentMiddle>
                          </RightLayoutContainer>
                        )
                      ) : showAimation[jobIndex] ? (
                        <RightLayoutContainer>
                          <ContentMiddle>
                            <div className="imageAnimate">
                              <div className="imageCover">
                                <LottieAnimation lotti={JobcardPrepare} />
                                <p>
                                  Our algorithms are cooking a job card for you{" "}
                                  <br />
                                  please wait, it will take less than a minute
                                </p>
                              </div>
                            </div>
                          </ContentMiddle>
                        </RightLayoutContainer>
                      ) : (
                        <>{leftJobcardTabBody(jobCardDetailsList[index], index)}</>
                      )}
                    </TabPane>
                  ))}

                {failedJobs &&
                  failedJobs?.map((failedJob) => {
                    const job = { jobcard: failedJob };
                    const solId = 1;
                    return (
                      <TabPane
                        key={failedJob.id}
                        tab={
                          <div className="deckleMatchIcon disabled">
                            <img src={failedIco} alt="" />
                            Failed job card
                          </div>
                        }
                        style={{ backgroundColor: "white" }}
                      >
                        {/* <Panes tab="Solution 1" key="1"> */}
                        <PageTitleComp style={{ borderBottom: "0" }}>
                          <PageHeader
                            ghost={false}
                            title="Job Card "
                          ></PageHeader>
                        </PageTitleComp>
                        <div className="MatchResult">
                          <Row span={24} className="pipeBlockCylinder">
                          {( ((!sizeExpanded && activeTab == '2') ||
                (!sizeExpanded && activeTab == '3') ||
               ( !sizeExpanded && activeTab == '4') ||
              (!sizeExpanded && activeTab == '5')) || activeTab == '1') &&  ( <Col
                              span={15}
                              className="pipeBlock"
                              style={{ paddingRight: "20px" }}
                            >
                              <RightSideSolution>
                                <div className="deckleCoverImage">
                                  <img
                                    src={deckleCover}
                                    alt="deckle match result"
                                  />
                                </div>
                                <div className="colLayoutBlock deckleErrorLayout">
                                  <p style={{ color: "#EA655B" }}>
                                    Job card could not be created for the input.
                                    Please check the input and try again
                                  </p>
                                </div>{" "}
                              </RightSideSolution>
                            </Col>
                        )}
                            <Col span={
                ((sizeExpanded && activeTab == '2') ||
                    (sizeExpanded && activeTab == '3') ||
                  ( sizeExpanded && activeTab == '4') ||
                  (sizeExpanded && activeTab == '5')) && activeTab != '1'
                  ? 24
                  : 9
              }    className="colLayoutBlock">
                              <Tabs
                              defaultActiveKey={activeTab}
                              activeKey={activeTab}
                              onChange={(key) => {
                                setCurrentSummaryTab(key);
                                setActiveTab(key);
                              }}
                            className="topPostTab innerPostTab"
                              >
                                <Panes
                                  tab="Summary"
                                  key="1"
                                  // disabled={solutionSummary?.solution1.exception}
                                >
                                  <Collapse
                                    className="sub-category"
                                    expandIconPosition="right"
                                    defaultActiveKey={["1", "2", "3", "4"]}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <CollapsePanel
                                      key="1"
                                      header="General Information"
                                    >
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <Col span={11}>
                                          {" "}
                                          <span>Product Specifications</span>
                                          <p
                                            style={{
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            {
                                              job.jobcard?.group?.product
                                                .product_spec
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Priority Quantity</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.forced_requirement_fulfilled
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.forced_requirement.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.forced_requirement
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .forced_requirement
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                      </Row>
                                    </CollapsePanel>

                                    <CollapsePanel
                                      key="2"
                                      header="Paper Machine"
                                    >
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Paper Machine</span>
                                          <p>
                                            {job.jobcard.group.machines[0].name}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Deckle Width</span>
                                          <p>{calculateDeckleSize(job)}</p>
                                        </Col>{" "}
                                      </Row>{" "}
                                    </CollapsePanel>
                                    <CollapsePanel key="3" header="Rewinding">
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Net Rewinding Qty</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.net_rewinding_quantity
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.net_rewinding_quantity.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.net_rewinding_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .net_rewinding_quantity
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Trim Loss</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.rewinding_net_trim_loss
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.rewinding_net_trim_loss.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.rewinding_net_trim_loss
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .rewinding_net_trim_loss
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Rewinder</span>{" "}
                                          <p>
                                            {
                                              job.jobcard?.group.machines?.filter(
                                                (item) =>
                                                  item.machine_type ===
                                                  "rewinder"
                                              )[0]?.rewinder_name
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Processed Order Qty</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.rewinder_processed_order_quantity
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.rewinder_processed_order_quantity.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.rewinder_processed_order_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .rewinder_processed_order_quantity
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Number of Unique Sets</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.unique_rewinding_partitions
                                              ? job.jobcard[`solution_${solId}`]
                                                  .data.summary
                                                  .unique_rewinding_partitions
                                              : 0}{" "}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Total Number of Sets</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.total_rewinding_partitions
                                              ? job.jobcard[`solution_${solId}`]
                                                  .data.summary
                                                  .total_rewinding_partitions
                                              : 0}{" "}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                    </CollapsePanel>
                                    <CollapsePanel key="4" header="Cutting">
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Net Cutting Qty</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.net_cutting_quantity
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.net_cutting_quantity.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.net_cutting_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .net_cutting_quantity
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Trim Loss</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.cutting_net_trim_loss
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.cutting_net_trim_loss.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.cutting_net_trim_loss
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .cutting_net_trim_loss
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Cutter</span>{" "}
                                          <p>
                                            {
                                              job.jobcard?.group.machines?.filter(
                                                (item) =>
                                                  item.machine_type === "cutter"
                                              )[0]?.cutter_name
                                            }
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Processed Order Qty</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.cutting_processed_order_quantity
                                              ? job.jobcard[
                                                  `solution_${solId}`
                                                ].data.summary.cutting_processed_order_quantity.toFixed(
                                                  3
                                                )
                                              : 0}{" "}
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary?.units
                                              ?.cutting_processed_order_quantity
                                              ? capitalize(
                                                  weightUnit[
                                                    job.jobcard[
                                                      `solution_${solId}`
                                                    ].data.summary?.units
                                                      .cutting_processed_order_quantity
                                                  ]?.displayName
                                                )
                                              : "T"}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                      <Row
                                        span={24}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          padding: "10px 0px",
                                        }}
                                      >
                                        {" "}
                                        <Col span={11}>
                                          <span>Number of Unique Sets</span>{" "}
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.unique_cutting_patterns
                                              ? job.jobcard[`solution_${solId}`]
                                                  .data.summary
                                                  .unique_cutting_patterns
                                              : 0}{" "}
                                          </p>
                                        </Col>
                                        <Col span={11}>
                                          <span>Total Number of Sets</span>
                                          <p>
                                            {job.jobcard[`solution_${solId}`]
                                              ?.data?.summary
                                              ?.total_cutting_partitions
                                              ? job.jobcard[`solution_${solId}`]
                                                  .data.summary
                                                  .total_cutting_partitions
                                              : 0}{" "}
                                          </p>
                                        </Col>{" "}
                                      </Row>{" "}
                                    </CollapsePanel>
                                  </Collapse>
                                </Panes>
                                <Panes
                                      tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }                                  key="4"
                                  // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                >
                                  <TableLayoutData>
                                    <div
                                      className="tableDataFormat"
                                      style={{ marginTop: "25px" }}
                                    >
                                      {isFetchingData ? (
                                        <TableShimmer
                                          header={unfulfilledColumnsHead}
                                          scroll={1300}
                                        />
                                      ) : (
                                        <Table
                                          columns={unfulfilledColumnsHead}
                                          dataSource={failedJobOrders}
                                          onChange={(pagination) =>
                                            onChange(pagination, true)
                                          }
                                          scroll={{ x: 1800 }}
                                          rowClassName={(record) =>
                                            record.priority && "true"
                                          }
                                          pagination={{
                                            current: currentPage,
                                            pageSize: pageSize,
                                            total: totalUnfulfilledOrders,
                                            onChange: onPaginationChange,
                                            showSizeChanger: true,
                                            showQuickJumper: true,
                                            // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                          }}
                                        />
                                      )}
                                    </div>
                                  </TableLayoutData>
                                </Panes>
                              </Tabs>
                            </Col>
                          </Row>
                        </div>
                        {/* </Panes> */}
                      </TabPane>
                    );
                  })}
              </Tabs>
            </DetailFields>
          </ResultWrap1>
        )}
        <ModalPopup visible={isAcceptModal}>
          <div className="Popup-img">
            <img src={warning} alt="Warning" />
          </div>
          <div className="Popup-content">
            <span>Send for approval?</span>
            <p>
              You are about to remove this order group, are you sure you want to
              continue?
            </p>
          </div>
          <div className="ant-modal-footer-section">
            <Button
              key="back"
              className="themeBtn-plane"
              onClick={() => acceptModalClose()}
              // disabled={solutionSummary?.solution2.exception}
            >
              <div className="plusPopUpBorder">
                <Iconmoon
                  icon="plus-sign"
                  size={9}
                  color="#EA655B"
                  className="ant-ico-sec"
                />
              </div>
              Cancel
            </Button>

            <Button
              key="submit"
              className="themeBtn"
              onClick={() => acceptModalConfirm()}
              // disabled={solutionSummary?.solution2.exception}
            >
              <Iconmoon icon="tick-mark" size={14} color="#ffff" />
              Confirm
            </Button>
          </div>
        </ModalPopup>

        {/* Discard Modal */}
        <ModalPopup visible={isDiscardModal}>
          <div className="Popup-img">
            <img src={warning} alt="Warning" />
          </div>
          <div className="Popup-content">
            <span>Discard the solution?</span>
            <p>
              You are about to discard this order group, are you sure you want
              to continue?
            </p>
          </div>
          <div className="ant-modal-footer-section">
            <Button
              key="back"
              className="themeBtn-plane"
              onClick={() => discardModalClose()}
            >
              <div className="plusPopUpBorder">
                <Iconmoon
                  icon="plus-sign"
                  size={9}
                  color="#EA655B"
                  className="ant-ico-sec"
                />
              </div>
              Cancel
            </Button>

            <Button
              key="submit"
              className="themeBtn"
              onClick={() => discardModalConfirm()}
            >
              <Iconmoon icon="tick-mark" size={14} color="#ffff" />
              Confirm
            </Button>
          </div>
        </ModalPopup>
        <ViewDeckleOrder
          selectedOrderNo={selectedOrderNo}
          // showButton={true}
          visible={viewOrder}
          onClose={closeViewDrawer}
          onCloseGrade={closeViewDrawer}
          category={selectedOrder?.category}

        />
      </RightLayoutContainer>
    )
  );
};

export default DeckleMatchResultsMultistage;
